import { useEffect, useRef, useState, useMemo } from 'react';
import {
    BrowserRouter as Router,
    Link,
    useParams,
    useNavigate
} from "react-router-dom";
import MInput from '../../Components/Input';
import MTable from '../../Components/MTable/MTable';
import Overlay from '../../Components/Overlay';
import MTextarea from '../../Components/TextArea';
import MSelect from '../../Components/MSelect';
import { getCountryAll, getProvince, getPOHeader, getPPN, getPromoMIReguler, getListProduk, getStok, createPOHeader, createPODetail, deletePODetail, getPromoMIPreo, getNPWP, getAddress, getCustInfo, submitDM, getListDiskon, ApplyListDiskon, submitDeduction, updatePOHeader, getOrderType, calculateAllCampaign } from '../../Service/PurchaseOrderService';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { empty_data, print, trash } from '../../Images';
import { NumberFormat } from '../../Components/NumberFormat';
import { ParseDecimal } from '../../Components/CurrencyInput/ParseDecimal';
import Swal from 'sweetalert2';
import Modal from '../../Components/Layout/Modal';
import ModalPromoPO from '../../Components/Sales/ModalPromoPO';
import { handlerFormError, isObjectEmpty } from '../../Utils/Utils';
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import PrintPO from './PrintPO';
import CurrencyInput from 'react-currency-input-field';
import { RadioButton } from 'primereact/radiobutton';
import ModalDiskonPO from '../../Components/Sales/ModalDiskonPO';
import { getExcludeGudang, getSO, getTransitWhsCabang } from '../../Service/SalesService';
import { includes, set } from 'lodash';
import { act } from 'react-dom/test-utils';
import { Button } from 'primereact/button';

let processingId = -1;
const { $ } = window;
const PurchaseForm = () => {
    let { userInfo } = useSelector(state => state.auth);
    const mTableP = useRef();
    const mTableF = useRef();
    const { pageState, id_po } = useParams();
    const deductionType = useRef();
    const deductionAmount = useRef();
    const deductionComment = useRef();
    const componentRef = useRef();
    const navigate = useNavigate();
    const [indent_warehouses, setIndentWarehouses] = useState([]);
    const [extra_so_data, setExtraSoData] = useState({});
    const [dm_errors, setDMErrors] = useState({
        type: "",
        message: ""
    })
    const [state, setState] = useState({
        m_pkp_amt: 0,
        locked_promo: false,
        processing: false,
        loading: false,
        refresh: false,
        ShipToCode: '',
        ShipToDesc: "",
        showProduct: false,
        disabled_deduction: false,
        disabled_pkp: false,
        order_id: '',
        order_no: '',
        so_number: '',
        status: '',
        modeDiskon: 'header',
        npwp: [],
        address_code: [],
        pkp_amount: 0,
        listPromo: [],
        listNpwp: [],
        listNpwp_Ori: [],
        listAddress: [],
        listDiskon: [],
        listordertype: [],
        listExcludeGudang: [],
        listTransitWhsCabang: [],
        posisi: 1,
        listPromoSelected: '',
        shipping_name: '',
        shipping_address: '',
        detail: [],
        country: [],
        province: [],
        city: [],
        locked: false,
        applypkp: false,
        need_deduction: false,
        deduction: 0,
        total: 0,
        total_dpp: 0,
        total_ppn: 0,
        total_discount: 0,
        kuota_default: 0,
        grand_total: 0,
        rekomendasi_pkp: 0,
        qty_selected: 0,
        item_seq_selected: '',
        item_no_selected: '',
        selectedRow: {},
        refresh_deduction: false,
        opsiProduct: {
            itemname: '',
            itemno: '',
            price: 0,
            qty: 1,
            type: 'Ready',
            paketid: '',
            gudang: '',
            grade: 'A'
        },
        opsiProductFree: {},
        listFreeDiskon: [],
        appliedAdditionalDiscount: [],
        supplier: [],
        listppn: [],
        sales_remark: "",
        infoSupplier: {
            U_M_BP_CODE_MI: '',
            kode_supplier: '',
            nama_supplier: '',
            phone: '',
            email: '',
            address: '',
            county_id: 'ID',
            province_id: '',
            city_id: '',
            required_date: moment().format('YYYY-MM-DD')
        },
        show: false,
        m_tp_penj: "FGS",
        direct_customer: false,
        show_direct_customer: false,
        gudang_mi: ''
    });
    const { country, province, city, detail, infoSupplier, locked, listppn, so_number, deduction, total, total_dpp, limit_kredit,
        total_ppn, total_discount, grand_total, pkp_amount, listPromo, refresh, listNpwp, listNpwp_Ori, order_no, listAddress,
        npwp, address_code, rekomendasi_pkp, applypkp, need_deduction, disabled_deduction, listDiskon, modeDiskon, refresh_deduction,
        listFreeDiskon, show, appliedAdditionalDiscount, item_seq_selected, item_no_selected, posisi, disabled_pkp, listordertype, m_tp_penj, m_pkp_amt,
        direct_customer, locked_promo, show_direct_customer, gudang_mi, listExcludeGudang, listTransitWhsCabang } = state;

    const options = [
        { value: 'ID', label: 'Indonesia' },
    ]

    const columns_product = [
        {
            id: 1, title: 'Item Description', field: 'ItemName', sortable: true,
            render: item => {
                return (
                    <a
                        onClick={onSelectProduct(item)}
                        style={{
                            cursor: 'pointer',
                            fontWeight: '500'
                        }}
                    >
                        {item.ItemName}
                    </a>
                )
            }
        },
        { id: 2, title: 'Model', field: 'U_SOL_EX_MODEL', sortable: true },
        {
            id: 3, title: 'Price/Unit', field: 'Price',
            render: item => {
                return NumberFormat(item.Price)
            }
        },

    ];

    const columns_product_free = [
        {
            id: 1, title: 'Item Description', field: 'ItemName', sortable: true,
            render: item => {
                return (
                    <a
                        onClick={onSelectProductFree(item)}
                        style={{
                            cursor: 'pointer',
                            fontWeight: '500'
                        }}
                    >
                        {item.ItemName}
                    </a>
                )
            }
        },
        { id: 2, title: 'Model', field: 'U_SOL_EX_MODEL', sortable: true },
        {
            id: 3, title: 'Price/Unit', field: 'Price',
            render: item => {
                return NumberFormat(item.Price)
            }
        },

    ];

    useEffect(_ => {
        if (refresh === true) {
            setState({ ...state, loading: true });
            initPage();
        }

    }, [refresh])

    const initPage = () => {
        const request = [
            getCountryAll({ perpage: 100 }).then(res => res.data.data),
            getPPN({
                filter: `"Segment_0":1106050,"Segment_2":${userInfo.BPLName}`,
                add_fields: ['"Segment_0"', '"Segment_2"']
            }).then(res => res.data.data),
            getOrderType({ perpage: 100 }).then(res => res.data.data),
            getExcludeGudang(1).then((res) => res.data.data),
            getTransitWhsCabang().then((res) => res.data.data),
        ];
        switch (pageState) {
            case 'create':
                if (userInfo.role_name == "SO Payment Verificator") {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: "You are not allowed to access that page!"
                    }).then(() => {
                        navigate('/purchaseorder')
                    })
                } else {
                    Promise.all(request).then(results => {
                        const [_country, _ppn, _ordertype, _exclude_gudang, _transit_whs_cabang] = results;

                        let _newCountry = _country.map(item => {
                            return {
                                label: item.Name,
                                value: item.Code
                            }
                        })
                        let _newOrderType = _ordertype.map(item => {
                            return {
                                label: item.Name,
                                value: item.Code
                            }
                        });
                        let _mi_cardcode = { nama_supplier: '', kode_supplier: '', U_M_BP_CODE_MI: '' }
                        for (const x in userInfo.MI_cardcode) {
                            if (userInfo.MI_cardcode[x].U_M_TP_TRSKS === 'FGS') {
                                _mi_cardcode.kode_supplier = userInfo.MI_cardcode[x].CardCode;
                                _mi_cardcode.nama_supplier = userInfo.MI_cardcode[x].CardName
                                _mi_cardcode.U_M_BP_CODE_MI = userInfo.MI_cardcode[x].U_M_BP_CODE_MI
                            }
                        }
                        let _infosup = {
                            ...state.infoSupplier,
                            nama_supplier: _mi_cardcode.nama_supplier,
                            kode_supplier: _mi_cardcode.kode_supplier,
                            U_M_BP_CODE_MI: _mi_cardcode.U_M_BP_CODE_MI
                        };

                        const reqMore = [
                            getNPWP(_mi_cardcode.U_M_BP_CODE_MI).then(res => res.data),
                            getAddress(_mi_cardcode.U_M_BP_CODE_MI).then(res => res.data),
                            getCustInfo(_mi_cardcode.U_M_BP_CODE_MI).then(res => res.data)
                        ];

                        Promise.all(reqMore).then(resultsMore => {
                            let ship_to_code = "";
                            let ship_to_desc = "";
                            const [_npwp, _address, _custinfo] = resultsMore;
                            let _newNpwp = _npwp.map(item => {
                                return {
                                    label: item.custNPWP + " (" + item.lineID + ")",
                                    value: item.lineID
                                }
                            })
                            let arr_address = [];
                            if (!isObjectEmpty(_custinfo)) {
                                if (!isObjectEmpty(_custinfo["shipping-address"])) {
                                    if (_custinfo["shipping-address"]["S"].length) {
                                        let addr = _custinfo["shipping-address"]["S"];
                                        ship_to_code = addr[0].Address;
                                        ship_to_desc = `${addr[0].addr}, ${addr[0].namecity}`;
                                    }
                                }
                            }
                            for (const row_address in _address) {
                                if (row_address == "S") {
                                    for (const rs in _address[row_address]) {
                                        arr_address.push({
                                            label: _address[row_address][rs].Address,
                                            value: _address[row_address][rs].Address,
                                            addr: _address[row_address][rs].addr,
                                            namecust: _address[row_address][rs].namecust,
                                            provinsi: _address[row_address][rs].countyCity.selected_propinsi_name,
                                            kota: _address[row_address][rs].countyCity.selected_kota,
                                        })
                                    }
                                }
                            }

                            let listppn = _ppn ? [..._ppn] : [];

                            if (includes(userInfo.role_name, "MHC Dealer")) {
                                listppn = [
                                    {
                                        "Name": "PPN keluaran 11%",
                                        "Rate": "11.000000",

                                    }
                                ];
                            }


                            setState({
                                ...state,
                                province: _newCountry,
                                infoSupplier: _infosup,
                                status: "DRAFT",
                                listppn: (userInfo.u_m_pkp == "Y" || includes(userInfo.role_name, "MHC Dealer")) ? listppn.filter(item => parseInt(item.Rate) > 0) : listppn.filter(item => parseInt(item.Rate) <= 0),
                                listNpwp: _newNpwp,
                                listordertype: _newOrderType,
                                listExcludeGudang: _exclude_gudang,
                                listTransitWhsCabang: _transit_whs_cabang,
                                listNpwp_Ori: _npwp,
                                listAddress: arr_address,
                                npwp: (_npwp.length > 0 ? _npwp[0] : []),
                                address_code: (arr_address.length > 0 ? arr_address[0] : []),
                                shipping_name: (arr_address.length > 0 ? arr_address[0].namecust : "-"),
                                shipping_address: (arr_address.length > 0 ? arr_address[0].addr : "-"),
                                loading: false,
                                netDisc: _custinfo.netDisc,
                                ShipToCode: ship_to_code,
                                ShipToDesc: ship_to_desc
                            });
                        })
                    })
                        .catch(function (err) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Get data failed',
                                text: err
                            });
                            setState({ ...state, loading: false })
                        });
                }

                break;
            case 'edit':
                request.push(getPOHeader(id_po).then(res => res.data));
                Promise.all(request).then(results => {
                    const [_country, _ppn, _ordertype, _exclude_gudang, _transit_whs_cabang, _po] = results;
                    if (userInfo.role_name == "SO Payment Verificator") {
                        if (_po.status != "Waiting Verification" && _po.verification_status === null) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: "You are not allowed to access that page!"
                            }).then(() => {
                                navigate('/purchaseorder')
                            })
                        }
                    }
                    let _newCountry = _country.map(item => {
                        return {
                            label: item.Name,
                            value: item.Code
                        }
                    })

                    let _newOrderType = _ordertype.map(item => {
                        return {
                            label: item.Name,
                            value: item.Code
                        }
                    });

                    let _infosup = {
                        ...state.infoSupplier,
                        nama_supplier: _po.cardname,
                        kode_supplier: _po.cardcode,
                        U_M_BP_CODE_MI: _po.mi_cardcode,
                        required_date: _po.docduedate
                    };

                    // automatic itung campaign PO
                    calculateAllCampaign(_po.docnumpo).then(res => {
                        let arr_detail = [];
                        let id_po = "";
                        let is_exist_sdfga = false;
                        _po.items = res.data.data;
                        for (const key in _po.items) {
                            let subtotal = (_po.items[key].totalbefdi * _po.items[key].qty);
                            let net_disc = _po.items[key].m_disc_1 ? parseFloat(_po.items[key].m_disc_1) / 100 : 0;
                            let disc_total = subtotal * net_disc;
                            let campaign_disc = parseFloat(_po.items[key].m_disc_2) / 100;
                            let prcntdisc = net_disc + ((1 - net_disc) * campaign_disc);

                            if (_po.items[key].whs == "WH-SDFGA") {
                                is_exist_sdfga = true;
                            }

                            id_po = _po.items[key].tr_purchaseorder_h_id

                            arr_detail.push({
                                itemname: _po.items[key].dscription,
                                itemno: _po.items[key].itemcode,
                                price: _po.items[key].totalbefdi,
                                qty: _po.items[key].qty,
                                type: (_po.items[key].mi_kd_cmpg?.substring(0, 4) == 'PREO' ? "Indent" : "Ready"),
                                paketid: _po.items[key].mi_kd_cmpg,
                                paket_name: _po.items[key].mi_ket_cmpg,
                                gudang: _po.items[key].whs,
                                free: (_po.items[key].linetotal == 0 ? 1 : 0),
                                id: _po.items[key].id,
                                ppn: _po.items[key].vatprcnt,
                                mi_add_disc: _po.items[key].mi_add_disc,
                                mi_ket_add_disc: _po.items[key].mi_ket_add_disc,
                                item_seq_dm: _po.items[key].item_seq_dm,
                                m_disc_3: parseFloat(_po.items[key].m_disc_3),
                                disc_item: parseFloat(_po.items[key].m_disc_2),
                                net_disc: parseFloat(_po.items[key].m_disc_1 ? _po.items[key].m_disc_1 : 0),
                                subtotal: subtotal - disc_total,
                                linetotal: parseFloat(_po.items[key].linetotal),
                                amount_dpp: parseFloat(_po.items[key].dpp),
                                amount_ppn: parseFloat(_po.items[key].ppn),
                                amount_discount: prcntdisc * subtotal,
                                item_seq_dm_asal: _po.items[key].item_seq_dm_asal,
                                grade: _po.items[key].grade,
                                additional_address: _po.items[key].additional_address,
                                additional_receiver: _po.items[key].additional_receiver,
                                additional_city: _po.items[key].additional_city,
                                additional_county: _po.items[key].additional_county,
                                additional_phone: _po.items[key].additional_phone,
                                kirim_ambil: _po.items[key].kirim_ambil,
                            });
                        }

                        let hitungan = Calculate(arr_detail);

                        const reqMore = [
                            getNPWP(_po.mi_cardcode).then(res => res.data),
                            getAddress(_po.mi_cardcode).then(res => res.data),
                            getCustInfo(_po.mi_cardcode).then(res => res.data)
                        ];


                        Promise.all(reqMore).then(resultsMore => {
                            const [_npwp, _address, _custinfo] = resultsMore;
                            let _newNpwp = _npwp.map(item => {
                                return {
                                    label: item.custNPWP + " (" + item.lineID + ")",
                                    value: item.lineID
                                }
                            })

                            let arr_address = [];
                            for (const row_address in _address) {
                                if (row_address == "S") {
                                    for (const rs in _address[row_address]) {
                                        arr_address.push({
                                            label: _address[row_address][rs].Address,
                                            value: _address[row_address][rs].Address,
                                            addr: _address[row_address][rs].Address?.substring(_address[row_address][rs].Address.length - 4) == 'S-99' ? _po.shipping_address : _address[row_address][rs].addr,
                                            namecust: _address[row_address][rs].Address?.substring(_address[row_address][rs].Address.length - 4) == 'S-99' ? _po.shipping_name : _address[row_address][rs].namecust,
                                            provinsi: _address[row_address][rs].countyCity.selected_propinsi_name,
                                            kota: _address[row_address][rs].countyCity.selected_kota
                                        })
                                    }
                                }
                            }
                            let addres_edit = [];
                            let address_selected = arr_address.filter(item => item.value == _po.mi_shiptocode);
                            if (_po.mi_shiptocode != null && _po.mi_shiptocode != "" && address_selected.length > 0) {
                                addres_edit = address_selected[0];
                            } else {
                                addres_edit = arr_address[0]
                                if (_po.docnumso !== "") {
                                    addres_edit = arr_address.filter(item => item.value?.substring(item.value.length - 4) == 'S-99');
                                    addres_edit = addres_edit.length > 0 ? addres_edit[0] : addres_edit;
                                }
                            }

                            let npwp_selected = _npwp.filter(item => item.lineID == _po.npwp_id);
                            let npwp_edit = [];
                            if (_po.npwp_id != null && _po.npwp_id != "" && npwp_selected.length > 0) {
                                npwp_edit = npwp_selected[0];
                            } else {
                                npwp_edit = _npwp[0]
                            }
                            let _rekomendasi_pkp = rekomendasi_amountpkp(_custinfo.pkp, _po.doctotal);
                            let _rekomendasi_pkp_kondisi = _rekomendasi_pkp;
                            if (_po.status == 'DRAFT' || _po.status == 'S') {
                                _rekomendasi_pkp_kondisi = _po.m_pkp_amt ? _po.m_pkp_amt : _rekomendasi_pkp;
                            } else {
                                _rekomendasi_pkp_kondisi = _po.m_pkp_amt ? _po.m_pkp_amt : 0;
                            }
                            let _need = true;
                            if (_po.status == 'DRAFT' || _po.status == 'S' || _po.status == 'Closed' || _po.status == "Waiting Verification") {
                                _need = false;
                            }

                            let _disable_pkp = true;
                            if ((_po.status == 'DRAFT' || _po.status == 'S') && _need == false && _custinfo.pkp > 0) {
                                _disable_pkp = false;
                            }
                            if (_po.status == 'DEDUCTION') {
                                _disable_pkp = false
                            }
                            if (_po.need_deduction) _need = true;
                            if (_po.docnumso) {
                                getSO({ filter: `DocNumSO:${_po.docnumso}` }).then(res => {
                                    if (res.status == 200 && res.data.data && res.data.data.length > 0) setExtraSoData(res.data.data[0]);
                                    else {
                                        Swal.fire({
                                            icon: 'error',
                                            title: `Sales Order retrieval error!`,
                                            text: "Please try again or contact support!"
                                        }).then(() => {
                                            navigate('/purchaseorder')
                                        });
                                    }
                                })
                            }

                            let listppn = _ppn ? [..._ppn] : [];
                            if (includes(userInfo.role_name, "MHC Dealer")) {
                                listppn = [
                                    {
                                        "Name": "PPN keluaran 11%",
                                        "Rate": "11.000000",

                                    }
                                ];
                            }

                            // cek apakah ada _po.whs di _exclude_gudang
                            let _exclude = _exclude_gudang.filter(item => item.code_name == userInfo.BPLName);
                            let _listingTransitIndex = _transit_whs_cabang.findIndex(transit => {
                                return transit.code_id === _infosup.U_M_BP_CODE_MI && arr_detail.some(detail => detail.gudang === transit.code_name);
                            });

                            //cek apakah ada gudang di arr_detail
                            let _gudang_exist_direct_customer = arr_detail.filter(item => item.gudang == _transit_whs_cabang[_listingTransitIndex]?.code_name);

                            let ppn_default = (userInfo.u_m_pkp == "Y" || includes(userInfo.role_name, "MHC Dealer")) ? listppn?.filter(item => parseInt(item.Rate) > 0) : listppn?.filter(item => parseInt(item.Rate) <= 0);
                            setState({
                                ...state,
                                m_pkp_amt: _po.m_pkp_amt,
                                province: _newCountry,
                                infoSupplier: _infosup,
                                order_no: _po.docnumpo,
                                order_id: id_po,
                                so_number: _po.docnumso,
                                status: _po.status,
                                appliedAdditionalDiscount: _po.appliedAdditionalDiscount,
                                listppn: ppn_default,
                                listNpwp: _newNpwp,
                                listNpwp_Ori: _npwp,
                                listAddress: arr_address,
                                detail: arr_detail,
                                grand_total: _po.doctotal,
                                deduction: _po.discsum,
                                total: hitungan.subtot,
                                total_dpp: hitungan.amount_dpp,
                                total_ppn: hitungan.amount_ppn,
                                total_discount: hitungan.amount_disc,
                                npwp: npwp_edit,
                                sales_remark: _po.sales_remark,
                                address_code: addres_edit,
                                shipping_name: (_po.shipping_name != "" ? _po.shipping_name : addres_edit.namecust),
                                shipping_address: (_po.shipping_address ? _po.shipping_address : addres_edit.addr),
                                pkp_amount: _custinfo.pkp,
                                rekomendasi_pkp: _po.m_pkp_amt && _po.m_pkp_amt > 0 ? _rekomendasi_pkp_kondisi : 0,
                                //applypkp: _po.m_pkp_amt && _po.m_pkp_amt > 0 ? true : ( _rekomendasi_pkp_kondisi > 0 ? true : 0 ),
                                applypkp: _po.m_pkp_amt && _po.m_pkp_amt > 0 ? true : false,
                                loading: false,
                                disabled_deduction: (_po.status == 'DRAFT' || _po.status == 'S' || _po.status == 'Closed' || _po.status == "PENDING DM" ? false : true),
                                need_deduction: _need,
                                locked_promo: _po.status != 'DRAFT' ? true : false,
                                locked: ((_po.status != 'DRAFT' && _po.docnumso == null) || _po.docnumso != null) ? true : false,
                                refresh_deduction: _po.status == "DEDUCTION" ? true : false,
                                show: false,
                                refresh: false,
                                verification_status: _po.verification_status,
                                verification_date: _po.verification_date,
                                verified_by: _po.verified_by,
                                verified_remark: _po.verified_remark,
                                disabled_pkp: _disable_pkp,
                                listordertype: _newOrderType,
                                listExcludeGudang: _exclude_gudang,
                                listTransitWhsCabang: _transit_whs_cabang,
                                m_tp_penj: _po.m_tp_penj,
                                gudang_mi: _po.whs,
                                show_direct_customer: _exclude.length > 0 && is_exist_sdfga || _gudang_exist_direct_customer.length > 0 ? true : false,
                                direct_customer: _po.direct_customer,
                            });


                        }).catch(function (err) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Get data failed',
                                text: "Data not found"
                            });
                            setState({ ...state, loading: false })
                        });
                    })
                        .catch(function (err) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Get Data Failed',
                                text: err
                            });
                            setState({ ...state, loading: false })
                        });


                }).catch(function (err) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Get Data Failed',
                        text: err
                    });
                    setState({ ...state, loading: false })
                });
                break;
        }
    }

    useEffect(_ => {
        initPage();
    }, [])

    useEffect(_ => {
        if (refresh_deduction) {
            getListDiskon({ order_id: order_no }).then((res) => {
                const _list_diskon = res.data.data;
                if (res.status == 200) {
                    setState({ ...state, listDiskon: _list_diskon, refresh_deduction: false });
                }
            }).catch(function (err) {
                Swal.fire({
                    icon: 'error',
                    title: 'No additional discount found',
                    text: "Please inform IT to add additional discount!"
                });
                setState({ ...state, loading: false })
            });
        }
    }, [refresh_deduction])

    const addProduct = () => {
        mTableP.current.reset();
        $('[name="inlineRadioOptions"]').prop('checked', false);
        setState({ ...state, showProduct: false });
        $("#modal-product").modal('show');
        document.querySelector('#modal-product-detail').style.display = 'block';
        document.querySelector('#modal-product-preorder').style.display = 'none';
    }

    const addProductFree = () => {
        mTableF.current.reset();
        setState({ ...state, showProduct: false });
        $("#modal-product-diskon-free").modal('show');
    }

    const addProductDetail = (item) => {
        if ((state.opsiProduct.type == '' && item.paketid?.substring(0, 4) !== 'PREO') || item.qty <= 0) {
            Swal.fire({
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                title: "Please choose type stok..!"
            });
            return;
        }

        if (detail.length == 0 && order_no == "") {
            let payload = {
                status: "DRAFT",
                m_tp_penj: state.m_tp_penj,
                direct_customer: state.direct_customer,
                docduedate: infoSupplier.required_date,
                npwp: state.npwp.custNPWP,
                npwp_id: state.npwp.lineID,
                shiptocode: state.ShipToCode,
                shiptodesc: state.ShipToDesc,
                cardcode: infoSupplier.kode_supplier,
                cardname: infoSupplier.nama_supplier,
                mi_cardcode: infoSupplier.U_M_BP_CODE_MI,
                mi_shiptocode: address_code.value,
                shipping_name: state.shipping_name,
                shipping_address: state.shipping_address,
                shipping_city: address_code.kota,
                shipping_county: address_code.provinsi,
                shipping_phone: "",
                shipping_mobilephone: "",
                net_disc: state.netDisc,
                items: [
                    {
                        itemcode: item.itemno,
                        vatprcnt: userInfo.u_m_pkp == "Y" ? 11 : 0,
                        qty: item.qty,
                        preorder: item.type === "Indent" ? 1 : 0,
                        vatgroup: listppn?.length > 0 ? listppn[0].Code : 0,
                        grade: item.grade,
                        whs: item.gudang_selected
                    }
                ]
            }

            if (item.paketid != "") {
                payload.items[0]['mi_kd_cmpg'] = item.paketid;
            }



            const response = createPOHeader(payload)
            response.then(res => {
                let _po = res.data.data;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Create purchase order success '
                }).then(res => {
                    $("#modal-product").modal('hide');
                    setState({ ...state, refresh: true, order_id: _po.id, order_no: _po.docnumpo });
                    navigate('/purchaseorder/edit/' + _po.docnumpo);
                });

            }).catch(({ response: { data } }) => {
                handlerFormError(data);
            }).finally(_ => stopProcessing());
        } else {
            startProcessing();
            let payload_detail = [
                {
                    itemcode: item.itemno,
                    vatprcnt: userInfo.u_m_pkp == "Y" ? 11 : 0,
                    qty: item.qty,
                    preorder: item.type === "Indent" ? 1 : 0,
                    whs: item.gudang_selected,
                    vatgroup: listppn?.length > 0 ? listppn[0].Code : 0,
                    grade: item.grade
                }
            ];
            if (item.paketid != "") {
                payload_detail[0]['mi_kd_cmpg'] = item.paketid;
            }
            const response_detail = createPODetail(state.order_no, payload_detail)
            response_detail.then(res => {
                let _po = res.data.PO;
                setAllHitungan(_po);
                $("#modal-product").modal('hide');
            }).catch(({ response: { data } }) => {
                handlerFormError(data);
            }).finally(_ => stopProcessing());
        }
    }

    const addProductDetailFree = (item) => {
        let arr = listFreeDiskon;
        if (item.qty === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Stock Empty!'
            });
            return;
        }
        let existingItemIndex = arr.findIndex(x => x.item_id === item.itemno);
        if (existingItemIndex < 0) {
            arr.push({
                item_id: item.itemno,
                itemname: item.itemname,
                harga: item.price,
                qty: item.qty,
                gudang: item.gudang_ready,
            });
        } else {
            listFreeDiskon[existingItemIndex].qty += item.qty;
        }


        setState({ ...state, listFreeDiskon: arr })
        $("#modal-product-diskon-free").modal('hide');
    }

    const applyPromo = () => {
        if (!locked) {
            setState({ ...state, listPromo: [] });
            $("#modal-promo-header").modal();
        }
    }

    const Calculate = (details) => {
        let subtot = 0;
        let amount_ppn = 0;
        let amount_dpp = 0;
        let amount_disc = 0;
        for (const key in details) {
            let amount = (details[key].qty * details[key].price);
            subtot += amount;
            amount_ppn += parseFloat(details[key].amount_ppn);
            amount_dpp += parseFloat(details[key].amount_dpp);
            amount_disc += parseFloat(details[key].amount_discount);
        }

        return { subtot, amount_ppn, amount_dpp, amount_disc };
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true,
    });

    const hapusDiskon = (row) => {

        let value = {
            discount_id: row.diskonid,
            item_mode: row.item_mode
        }
        let data = {
            remark: row.diskon_keterangan,
            value: 0
        }
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-modena',
                cancelButton: 'btn btn-readonly mr-3'
            },
            buttonsStyling: false
        })
        swalWithBootstrapButtons.fire(
            {
                title: 'Confirmation',
                text: 'Are you sure Delete this Discount ?',
                confirmButtonColor: '#3085d6',
                showCancelButton: true,
                confirmButtonText: 'Sure',
                reverseButtons: true
            }
        ).then(({ isConfirmed }) => {
            if (isConfirmed) {
                saveDiskon(value, data, 'delete')
            }
        })
    }

    const saveDiskon = (value, data, act) => {
        setState({ ...state, loading: true, processing: true });
        const formData = new FormData();
        formData.append("order_id", state.order_no);
        formData.append("discount_id", value.discount_id);
        formData.append("remark", data.remark);

        if (data.file) {
            formData.append("file", data.file);
        }

        switch (value.item_mode) {
            case 'free_item':
                if (listFreeDiskon.length == 0 && act == 'create') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Warning',
                        text: 'Items Required!'
                    });
                } else {
                    if (act == 'create') {
                        formData.append("items", JSON.stringify(listFreeDiskon));
                    }
                    setState({ ...state, processing: true, loading: true });
                    ApplyListDiskon(formData, res => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Apply Discount Success'
                        }).then(res => {
                            setState({ ...state, refresh: true, show: false, listFreeDiskon: [], processing: false, loading: false });
                            navigate('/purchaseorder/edit/' + state.order_no);
                        });
                    }, ({ response }) => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Apply Discount Error',
                            text: response.data.message
                        });
                    }).finally(() => {
                        setState({ ...state, processing: false, loading: false });
                    });
                }
                break;
            case 'detail':
                let _item = [];
                for (const y in appliedAdditionalDiscount) {
                    if (appliedAdditionalDiscount[y].diskonid == value.discount_id) {
                        for (const x in appliedAdditionalDiscount[y].items) {
                            if (act == 'edit') { //hapus per items
                                if (data.item_seq !== appliedAdditionalDiscount[y].items[x].item_seq) {
                                    _item.push({
                                        item_seq: appliedAdditionalDiscount[y].items[x].item_seq,
                                        qty: appliedAdditionalDiscount[y].items[x].kuantitas
                                    })
                                }
                            } else {
                                _item.push({
                                    item_seq: appliedAdditionalDiscount[y].items[x].item_seq_asal && appliedAdditionalDiscount[y].items[x].item_seq_asal !== null ? appliedAdditionalDiscount[y].items[x].item_seq_asal : appliedAdditionalDiscount[y].items[x].item_seq,
                                    qty: appliedAdditionalDiscount[y].items[x].kuantitas
                                })
                            }
                        }
                    }
                }
                if (act == 'create') {
                    _item.push({
                        item_seq: item_seq_selected,
                        item_id: item_no_selected,
                        qty: data.qty
                    })
                }
                formData.append("value", data.value);
                if (act == 'create' || act == 'edit') {
                    formData.append("items", JSON.stringify(_item));
                    if (data.value == null || data.value == 0 || data.value == "") {
                        Swal.fire({
                            icon: 'error',
                            title: 'Warning',
                            text: 'Value Required!'
                        });
                    }
                }
                setState({ ...state, processing: true, loading: true });
                ApplyListDiskon(formData, res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Apply Discount Success'
                    }).then(res => {
                        setState({ ...state, refresh: true, show: false, listFreeDiskon: [], processing: false, loading: false });
                        navigate('/purchaseorder/edit/' + state.order_no);
                    });
                }, ({ response }) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Apply Discount Error',
                        text: response.data.message
                    });
                }).finally(() => {
                    setState({ ...state, processing: false, loading: false });
                });

                break;
            case 'header':
                formData.append("value", data.value);

                setState({ ...state, processing: true, loading: true });
                ApplyListDiskon(formData, res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Apply Discount Success'
                    }).then(res => {
                        setState({ ...state, refresh: true, show: false, listFreeDiskon: [], processing: false, loading: false });
                        navigate('/purchaseorder/edit/' + state.order_no);
                    });
                }, ({ response }) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Apply Discount Error',
                        text: response.data.message
                    });
                }).finally(() => {
                    setState({ ...state, processing: false, loading: false });
                });
                break;
        }


    }

    const minus = (flag) => {
        if (flag == 0) { //Promo
            if (state.opsiProduct.type == '') {
                Swal.fire({
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                    title: "Please choose type stok..!"
                });
                return;
            }
            let min = state.opsiProduct.qty - 1;
            if (min <= 0) {
                min = 1;
            }
            const _opsiProduct = { ...state.opsiProduct, qty: min };
            setState({ ...state, opsiProduct: _opsiProduct });
        } else if (flag == 1) { //Additional Diskon
            let min = state.opsiProductFree.qty - 1;
            if (min <= 0) {
                min = 1;
            }
            const _opsiProduct = { ...state.opsiProductFree, qty: min };
            setState({ ...state, opsiProductFree: _opsiProduct });
        }

    }
    const plus = (flag) => {
        if (flag == 0) { //Promo
            if (state.opsiProduct.type == '') {
                Swal.fire({
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                    title: "Please choose type stok..!"
                });
                return;
            }
            let pls = state.opsiProduct.qty;
            if ((state.opsiProduct.type == "I" && state.opsiProduct.type == "Indent") && state.opsiProduct.qty < state.opsiProduct.qty_indent) {
                pls++;
                const _opsiProduct = { ...state.opsiProduct, qty: pls };
                setState({ ...state, opsiProduct: _opsiProduct });
            }
            if ((state.opsiProduct.type == "R" || state.opsiProduct.type == "Ready") && state.opsiProduct.qty < state.opsiProduct.qty_ready) {
                pls++;
                const _opsiProduct = { ...state.opsiProduct, qty: pls };
                setState({ ...state, opsiProduct: _opsiProduct });
            }
        } else { //Aditional Diskon
            let pls = state.opsiProductFree.qty;
            if ((state.opsiProduct.type == "R" || state.opsiProduct.type == "Ready") && state.opsiProductFree.qty < state.opsiProductFree.qty_ready) {
                pls++;
                const _opsiProduct = { ...state.opsiProductFree, qty: pls };
                setState({ ...state, opsiProductFree: _opsiProduct });
            }
        }
    }

    const promo = (item) => {
        setState({ ...state, processing: true, listPromo: [] });
        $('[name="radio"]').prop('checked', false);
        if (item.type == "Indent") {
            getPromoMIPreo({
                order_id: order_no,
                dealer_id: infoSupplier.U_M_BP_CODE_MI,
                item_id: item.itemno,
                gudang_cabang: item.gudang
            })
                .then(res => {
                    if (res.data.status == 500) {
                        Swal.fire({
                            icon: 'error',
                            title: res.data.message
                        });
                    } else {
                        let filteredArray = res.data;
                        let _kuota = 0;
                        const index = filteredArray.findIndex(e => e.paketid == item.paketid);
                        if (index > -1) {
                            filteredArray[index].checked = true;
                            _kuota = filteredArray[index].kuota
                        }
                        setTimeout(() => {
                            setState({
                                ...state,
                                listPromo: filteredArray,
                                listPromoSelected: item.id,
                                qty_selected: item.qty,
                                paket_selected: item.paketid,
                                kuota_default: _kuota
                            });
                        }, 200);
                    }
                }).catch(({ response: { data } }) => {
                    handlerFormError(data);
                    setTimeout(() => {
                        setState({ ...state, listPromo: [] });
                    }, 200);
                }).finally(_ => stopProcessing());
        } else {
            getPromoMIReguler({
                order_id: order_no,
                dealer_id: infoSupplier.U_M_BP_CODE_MI,
                item_id: item.itemno,
                gudang_cabang: item.gudang,
                BPLId: "BRANCH|" + userInfo.BPLId + "|" + userInfo.BPLName
            })
                .then(res => {
                    if (res.data.status == 500) {
                        Swal.fire({
                            icon: 'error',
                            title: res.data.message
                        });
                    } else {
                        let filteredArray = res.data;
                        const index = filteredArray.findIndex(e => e.paketid == item.paketid);
                        if (index > -1) {
                            filteredArray[index].checked = true;
                        }
                        setTimeout(() => {
                            setState({
                                ...state,
                                listPromo: filteredArray,
                                listPromoSelected: item.id,
                                qty_selected: 0,
                                paket_selected: item.paketid
                            });
                        }, 200);
                    }
                }).catch(({ response: { data } }) => {
                    handlerFormError(data);
                    setTimeout(() => {
                        setState({ ...state, listPromo: [] });
                    }, 200);
                }).finally(_ => stopProcessing());
        }
        $("#modal-promo").modal();
    }

    const cancelpromo = (item) => {
        let filteredArray = [];
        filteredArray = detail;
        const index = filteredArray.findIndex(e => e.id == item.id);
        if (index > -1) {
            startProcessing();
            let payload_detail = [
                {
                    itemcode: filteredArray[index].itemno,
                    qty: item.paketid?.substring(0, 4) == 'PREO' ? item.qty : filteredArray[index].qty,
                    mi_kd_cmpg: "",
                    mi_ket_cmpg: "",
                    id: item.id,
                    whs: filteredArray[index].gudang,
                    action: "delete"
                }
            ];
            const response_detail = createPODetail(state.order_no, payload_detail)
            response_detail.then(res => {
                let _po = res.data.PO;
                setAllHitungan(_po);
                $("#modal-promo").modal('hide');
            }).catch(({ response: { data } }) => {
                handlerFormError(data);
            }).finally(_ => stopProcessing());
        }
    }

    const onChangeNPWP = (e) => {
        let _npwp = e.value;
        let npwp_selected = listNpwp_Ori.filter(item => item.lineID == _npwp);
        if (state.order_id !== null && state.order_id !== "") {
            const response_so_update = updatePOHeader(state.order_no,
                {
                    npwp: npwp_selected.length > 0 ? npwp_selected[0].custNPWP : [],
                    npwp_id: _npwp

                });
            response_so_update.then(res_so => {
                setState({ ...state, npwp: npwp_selected.length > 0 ? npwp_selected[0] : [] });
            })
        } else {
            setState({ ...state, npwp: npwp_selected.length > 0 ? npwp_selected[0] : [] });
        }
    }

    const onChangeOrderType = (e) => {
        setState({ ...state, loading: true });
        let _type = e.value;
        let cardcodes = [...userInfo.MI_cardcode];
        cardcodes = cardcodes.filter((item) => {
            return item.CardName.indexOf(_type) > -1
        })

        const info_supplier = { ...infoSupplier };

        if (cardcodes[0]) {
            info_supplier.kode_supplier = cardcodes[0].CardCode;
            info_supplier.nama_supplier = cardcodes[0].CardName;
            info_supplier.U_M_BP_CODE_MI = cardcodes[0].U_M_BP_CODE_MI;
        } else {
            Swal.fire({
                icon: 'error',
                title: "Get Data Failed",
                text: "Customer data is not found for that order type!"
            }).then(() => {
                setState({ ...state, loading: false })
            });
        }

        const reqMore = [
            getNPWP(info_supplier.U_M_BP_CODE_MI).then(res => res.data),
            getAddress(info_supplier.U_M_BP_CODE_MI).then(res => res.data),
            getCustInfo(info_supplier.U_M_BP_CODE_MI).then(res => res.data)
        ];

        if (state.order_id !== null && state.order_id !== "") {
            const response_so_update = updatePOHeader(state.order_no,
                {
                    m_tp_penj: _type,
                    cardcode: info_supplier.kode_supplier,
                    cardname: info_supplier.nama_supplier,
                    mi_cardcode: info_supplier.U_M_BP_CODE_MI,
                    mi_shiptocode: info_supplier.U_M_BP_CODE_MI + '-S-99'
                });
            response_so_update.then(() => {
                Promise.all(reqMore).then(resultsMore => {
                    let ship_to_code = "";
                    let ship_to_desc = "";
                    const [_npwp, _address, _custinfo] = resultsMore;
                    let _newNpwp = _npwp.map(item => {
                        return {
                            label: item.custNPWP + " (" + item.lineID + ")",
                            value: item.lineID
                        }
                    })

                    if (!isObjectEmpty(_custinfo)) {
                        if (!isObjectEmpty(_custinfo["shipping-address"])) {
                            if (_custinfo["shipping-address"]["S"].length) {
                                let addr = _custinfo["shipping-address"]["S"];
                                ship_to_code = addr[0].Address;
                                ship_to_desc = `${addr[0].addr}, ${addr[0].namecity}`;
                                updatePOHeader(state.order_no, {
                                    shiptocode: ship_to_code,
                                    shiptodesc: ship_to_desc
                                })
                            }
                        }
                    }

                    let arr_address = [];
                    for (const row_address in _address) {
                        if (row_address == "S") {
                            for (const rs in _address[row_address]) {
                                arr_address.push({
                                    label: _address[row_address][rs].Address,
                                    value: _address[row_address][rs].Address,
                                    addr: _address[row_address][rs].addr,
                                    namecust: _address[row_address][rs].namecust,
                                    provinsi: _address[row_address][rs].countyCity.selected_propinsi_name,
                                    kota: _address[row_address][rs].countyCity.selected_kota,
                                })
                            }
                        }
                    }
                    setState({
                        ...state,
                        listNpwp: _newNpwp,
                        listNpwp_Ori: _npwp,
                        listAddress: arr_address,
                        npwp: (_npwp.length > 0 ? _npwp[0] : []),
                        address_code: (arr_address.length > 0 ? arr_address[0] : []),
                        shipping_name: (arr_address.length > 0 ? arr_address[0].namecust : "-"),
                        shipping_address: (arr_address.length > 0 ? arr_address[0].addr : "-"),
                        netDisc: _custinfo.netDisc,
                        m_tp_penj: _type, infoSupplier: info_supplier, loading: false,
                        ShipToCode: ship_to_code,
                        ShipToDesc: ship_to_desc
                    });
                }).catch(() => {
                    Swal.fire({
                        icon: 'error',
                        title: "Get Data Failed",
                        text: "Customer data is not found for that order type!"
                    }).then(() => {
                        setState({ ...state, loading: false })
                    });
                })
            })
        } else {
            Promise.all(reqMore).then(resultsMore => {
                let ship_to_code = "";
                let ship_to_desc = "";
                const [_npwp, _address, _custinfo] = resultsMore;
                let _newNpwp = _npwp.map(item => {
                    return {
                        label: item.custNPWP + " (" + item.lineID + ")",
                        value: item.lineID
                    }
                })
                let arr_address = [];

                if (!isObjectEmpty(_custinfo)) {
                    if (!isObjectEmpty(_custinfo["shipping-address"])) {
                        if (_custinfo["shipping-address"]["S"].length) {
                            let addr = _custinfo["shipping-address"]["S"];
                            ship_to_code = addr[0].Address;
                            ship_to_desc = `${addr[0].addr}, ${addr[0].namecity}`;
                        }
                    }
                }

                for (const row_address in _address) {
                    if (row_address == "S") {
                        for (const rs in _address[row_address]) {
                            arr_address.push({
                                label: _address[row_address][rs].Address,
                                value: _address[row_address][rs].Address,
                                addr: _address[row_address][rs].addr,
                                namecust: _address[row_address][rs].namecust,
                                provinsi: _address[row_address][rs].countyCity.selected_propinsi_name,
                                kota: _address[row_address][rs].countyCity.selected_kota,
                            })
                        }
                    }
                }
                setState({
                    ...state,
                    listNpwp: _newNpwp,
                    listNpwp_Ori: _npwp,
                    listAddress: arr_address,
                    npwp: (_npwp.length > 0 ? _npwp[0] : []),
                    address_code: (arr_address.length > 0 ? arr_address[0] : []),
                    shipping_name: (arr_address.length > 0 ? arr_address[0].namecust : "-"),
                    shipping_address: (arr_address.length > 0 ? arr_address[0].addr : "-"),
                    netDisc: _custinfo.netDisc,
                    m_tp_penj: _type, infoSupplier: info_supplier, loading: false,
                    ShipToCode: ship_to_code,
                    ShipToDesc: ship_to_desc
                });
            }).catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: "Get Data Failed",
                    text: "Customer data is not found for that order type!"
                }).then(() => {
                    setState({ ...state, loading: false })
                });
            })
        }
    }

    const onChangeAddressCode = (e) => {
        let addres = e.value;
        let addres_selected = listAddress.filter(item => item.value == addres);
        setState({
            ...state,
            address_code: addres_selected.length > 0 ? addres_selected[0] : [],
            shipping_address: addres_selected.length > 0 ? addres_selected[0].addr : "-",
            shipping_name: addres_selected.length > 0 ? addres_selected[0].namecust : "-",
            ShipToCode: addres_selected.length > 0 ? addres_selected[0].label : "-",
            ShipToDesc: addres_selected.length > 0 ? `${addres_selected[0].addr}, ${addres_selected[0].kota}` : "-",
        });
    }

    const onChangePPN = (e, row) => {
        let ppn = e.target.value;
        let ppn_group = e.target[e.target.selectedIndex].getAttribute('data-ppn-code');
        startProcessing();
        let payload_detail = [
            {
                itemcode: row.itemno,
                qty: row.qty,
                mi_kd_cmpg: row.paketid,
                id: row.id,
                vatprcnt: ppn,
                vatgroup: ppn_group
            }
        ];
        const response_detail = createPODetail(state.order_no, payload_detail)
        response_detail.then(res => {
            let _po = res.data.PO;
            setAllHitungan(_po);

        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        }).finally(_ => stopProcessing());
    }

    const onChangeWarehouseFree = (e) => {
        setState({ ...state, processing: true })
        const whs = e.target.value;
        let current_ready = 0;
        let qty_ready = e.target[e.target.selectedIndex].getAttribute("data-stock");
        $('[name="inlineRadioOptions"]').prop('checked', false);
        detail.forEach(datum => {
            if (datum.itemno == state.opsiProductFree.itemno) {
                //if(datum.type == "Ready" && datum.gudang == whs) current_ready += parseInt(datum.qty);
            }
        })
        // ditambah dengan current_ready dari pengajuan free item
        let current_ready_free = 0;
        listFreeDiskon.forEach(datum => {
            if (datum.item_id == state.opsiProductFree.itemno && datum.gudang == whs) {
                current_ready_free += parseInt(datum.qty);
            }
        });

        setState({
            ...state,
            showProduct: true,
            processing: false,
            opsiProductFree: {
                itemname: state.opsiProductFree.itemname,
                itemno: state.opsiProductFree.itemno,
                price: state.opsiProductFree.price,
                qty: qty_ready > 0 ? 1 : 0,
                mata_uang: state.opsiProductFree.mata_uang,
                type: state.opsiProductFree.type,
                paketid: state.opsiProductFree.paketid,
                qty_ready: qty_ready - current_ready - current_ready_free > 0 ? qty_ready - current_ready - current_ready_free : 0,
                gudang_ready: whs,
                gudang_selected: whs,
            }
        });

    }

    const onChangeWarehouse = (e) => {
        setState({ ...state, processing: true })
        const whs = e.target.value;
        let current_indent = 0;
        let current_ready = 0;
        let qty_ready = e.target[e.target.selectedIndex].getAttribute("data-stock");
        $('[name="inlineRadioOptions"]').prop('checked', false);


        const listingTransitIndex = state.listTransitWhsCabang.findIndex(transit => transit.code_name === whs);
        if (listingTransitIndex !== -1) {
            const listingTransit = state.listTransitWhsCabang[listingTransitIndex];
            let payload = {
                mi_cardcode: state.infoSupplier.U_M_BP_CODE_MI,
                items: [
                    {
                        item: state.opsiProduct.itemno,
                        comparator: state.opsiProduct.itemno,
                        preorder: 1
                    }
                ],
                whs: listingTransit.code_name,
            }

            getStok(payload).then(res => {
                let dataStok = res.data;

                let index = dataStok[state.opsiProduct.itemno].findIndex(item => item.gudang === whs);
                let qty_ready = dataStok[state.opsiProduct.itemno][index].stok;

                detail.forEach(datum => {
                    if (datum.itemno == state.opsiProduct.itemno) {
                        if (datum.type == "Ready" && datum.gudang == whs) current_ready += parseInt(datum.qty);
                        else if (datum.type == "Indent") current_indent += parseInt(datum.qty);
                    }
                })

                setState({
                    ...state,
                    showProduct: true,
                    processing: false,
                    opsiProduct: {
                        temname: state.opsiProduct.itemname,
                        itemno: state.opsiProduct.itemno,
                        price: state.opsiProduct.price,
                        qty: qty_ready > 0 ? 1 : 0,
                        mata_uang: state.opsiProduct.mata_uang,
                        type: state.opsiProduct.type,
                        paketid: state.opsiProduct.paketid,
                        qty_ready: qty_ready - current_ready,
                        gudang_ready: whs,
                        qty_indent: state.opsiProduct.qty_indent - current_indent,
                        gudang_indent: state.opsiProduct.gudang_indent,
                        gudang_selected: whs,
                    }
                });
            }).catch(({ response: { data } }) => {
                handlerFormError(data);
            })
        } else {
            detail.forEach(datum => {
                if (datum.itemno == state.opsiProduct.itemno) {
                    if (datum.type == "Ready" && datum.gudang == whs) current_ready += parseInt(datum.qty);
                    else if (datum.type == "Indent") current_indent += parseInt(datum.qty);
                }
            })

            setState({
                ...state,
                showProduct: true,
                processing: false,
                opsiProduct: {
                    itemname: state.opsiProduct.itemname,
                    itemno: state.opsiProduct.itemno,
                    price: state.opsiProduct.price,
                    qty: qty_ready > 0 ? 1 : 0,
                    mata_uang: state.opsiProduct.mata_uang,
                    type: state.opsiProduct.type,
                    paketid: state.opsiProduct.paketid,
                    qty_ready: qty_ready - current_ready,
                    gudang_ready: whs,
                    qty_indent: state.opsiProduct.qty_indent - current_indent,
                    gudang_indent: state.opsiProduct.gudang_indent,
                    gudang_selected: whs,
                }
            });
        }


    }

    const onChangeApplyPKP = (e) => {
        const _pkp = e.target.checked;
        let _rekomendasi_amountpkp = 0;
        if (_pkp) {
            _rekomendasi_amountpkp = rekomendasi_amountpkp(pkp_amount, grand_total);
            setState({ ...state, rekomendasi_pkp: _rekomendasi_amountpkp, applypkp: _pkp, pkp_amount: state.pkp_amount - _rekomendasi_amountpkp });
            updatePOHeader(state.order_no, { m_pkp_amt: _rekomendasi_amountpkp });
        } else {
            let __temp_rekomendasi_pkp = state.rekomendasi_pkp;
            setState({ ...state, rekomendasi_pkp: _rekomendasi_amountpkp, applypkp: _pkp, pkp_amount: parseFloat(state.pkp_amount) + parseFloat(__temp_rekomendasi_pkp) });
            updatePOHeader(state.order_no, { m_pkp_amt: _rekomendasi_amountpkp });
        }

    }

    const onChangeApplyDirectCustomer = (e) => {
        const _direct = e.target.checked;
        setState({ ...state, direct_customer: _direct });
    }

    const setKirimAmbilChecked = async (e, i, id) => {
        let _kirim_ambil = e.target.checked ? 1 : 0;
        let payload_detail = [
            {
                id: state.detail[i].id,
                kirim_ambil: _kirim_ambil,
                whs: state.detail[i].gudang
            }
        ];
        await createPODetail(state.order_no, payload_detail);
        setState({
            ...state,
            detail: state.detail.map((item) => item.id === id ? { ...item, kirim_ambil: _kirim_ambil } : item)
        });
    }

    useEffect(() => {
        if (m_pkp_amt && m_pkp_amt > 0) {
            setState({ ...state, applypkp: true });
        }
    }, [m_pkp_amt])

    const onChangeNeedDeduction = (e) => {
        let pkp = 0;
        let _apply = false;
        if (!e.target.checked) {
            pkp = rekomendasi_amountpkp(pkp_amount, grand_total)
            _apply = true;
        }
        setState({
            ...state,
            need_deduction: e.target.checked,
            rekomendasi_pkp: pkp,
            applypkp: _apply,
            disabled_pkp: !_apply
        });
    }

    const onDateDeliveryChange = (event) => {
        let tgl = moment(event.target.value).format('YYYY-MM-DD');
        let today = moment()
        if (today.diff(tgl, 'days') > 0) {
            Swal.fire({
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                title: "Date cannot be lower than today..!"
            });
        }
        if (state.order_id !== null && state.order_id !== "") {
            const response_so_update = updatePOHeader(state.order_no, { docduedate: event.target.value });
            response_so_update.then(res_so => {
                const _infoSupplier = { ...state.infoSupplier, required_date: tgl };
                setState({ ...state, infoSupplier: _infoSupplier });
            })
        } else {
            const _infoSupplier = { ...state.infoSupplier, required_date: event.target.value };
            setState({ ...state, infoSupplier: _infoSupplier });
        }
    }

    const onEditableChange = (e) => {
        let pkp = rekomendasi_amountpkp(pkp_amount, grand_total);
        if (e < pkp) {
            pkp = e
        }

        setState({ ...state, rekomendasi_pkp: ParseDecimal(pkp) });

        // if(state.order_no !== null) {
        //     const response_so_update = updatePOHeader(state.order_no,{m_pkp_amt : pkp});
        //     response_so_update.then(res_so => {
        //         setState({ ...state, rekomendasi_pkp: ParseDecimal(pkp)});
        //     })
        // }

    }

    const onRemoveProduct = (row) => {
        let payload = {
            id: [row.id]
        }

        deletePODetail(state.order_no, payload, res => {
            if (res.status == 200 || res.status == 201) {
                let _po = res.data.PO;

                Swal.fire({
                    icon: 'success',
                    title: 'Delete data success',
                    text: 'Data has been deleted!'
                }).then(result => {
                    setAllHitungan(_po);
                });
            }
        }, ({ response: { data } }) => {
            Swal.fire({
                icon: 'error',
                title: 'Delete data fail',
                text: data.message
            });
        });
    }

    const disableRemark = (status, role_name) => {
        if (role_name == "SO Payment Verificator") return true;
        else if (status !== "DRAFT" && status !== "PENDING DM" && status !== "" && status !== null) return true;
        else return false;
    }

    const onRadioChange = (e, gd) => {
        const _opsiProduct = { ...state.opsiProduct, type: e.target.value, gudang_selected: gd };
        setState({ ...state, opsiProduct: _opsiProduct });
    }

    const onSelectProduct = item => () => {
        setIndentWarehouses([]);
        $('[name="inlineRadioOptions"]').prop('checked', false);
        let payload = {
            mi_cardcode: state.infoSupplier.U_M_BP_CODE_MI,
            items: [
                {
                    item: item.ItemCode.split(".")[0],
                    comparator: item.ItemCode,
                    preorder: 1
                }
            ],
            //grade: item.grade
        }

        setState({ ...state, processing: true })
        getStok(payload).then(res => {
            let indent_whs = [];
            let dataStok = res.data;
            let ready = 0;
            let indent = 0;
            let gd_ready = "";
            let gd_indent = "";
            let mata_uang = "";
            let campaign = "";
            let current_indent = 0;
            let current_ready = 0;
            for (const key in dataStok) {
                if (key !== payload.items[0].comparator) continue
                mata_uang = dataStok[key].mata_uang;
                if (dataStok[key].campaign_preorder != undefined && dataStok[key].campaign_preorder != null) {
                    indent = dataStok[key].stok;
                    gd_indent = dataStok[key].gudang;
                    campaign = dataStok[key].campaign_preorder;
                } else {
                    indent_whs = dataStok[key];
                }
            }
            if (indent_whs.length) {
                ready = indent_whs[0].stok;
                gd_ready = indent_whs[0].gudang;

                setIndentWarehouses(indent_whs);
            }
            for (const y in state.listTransitWhsCabang) {
                if (state.listTransitWhsCabang[y].code_id == state.infoSupplier.U_M_BP_CODE_MI) {
                    let transit = {
                        nama_item: indent_whs[0].nama_item,
                        itemno_negara: indent_whs[0].itemno_negara,
                        itemno: indent_whs[0].itemno,
                        qty: indent_whs[0].stok,
                        gudang: state.listTransitWhsCabang[y].code_name,
                        harga: indent_whs[0].harga,
                        mata_uang: indent_whs[0].mata_uang,
                        pricelist: indent_whs[0].pricelist,
                        stok: 0,
                        recheck: 1
                    }
                    setIndentWarehouses(prevState => [...prevState, transit]);
                }
            }

            detail.forEach(datum => {
                if (datum.itemno == item.ItemCode) {
                    if (datum.type == "Ready" && datum.gudang == gd_ready) {
                        current_ready += parseInt(datum.qty);
                    }
                    else if (datum.type == "Indent") current_indent += parseInt(datum.qty);
                }
            })

            setState({
                ...state,
                showProduct: true,
                processing: false,
                opsiProduct: {
                    itemname: item.ItemName,
                    itemno: item.ItemCode,
                    price: item.Price,
                    qty: 1,
                    mata_uang: mata_uang,
                    type: ready - current_ready > 0 ? "Ready" : "",
                    paketid: campaign,
                    qty_ready: ready - current_ready,
                    gudang_ready: gd_ready,
                    qty_indent: indent - current_indent,
                    gudang_indent: gd_indent,
                    gudang_selected: gd_ready,
                }
            });
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        })
    };

    const onSelectProductFree = item => () => {
        setIndentWarehouses([]);
        let payload = {
            mi_cardcode: state.infoSupplier.U_M_BP_CODE_MI,
            items: [
                {
                    item: item.ItemCode.split(".")[0],
                    comparator: item.ItemCode,
                    preorder: 0
                }
            ],
            grade: "A"
        }

        setState({ ...state, processing: true })
        getStok(payload).then(res => {
            let indent_whs = [];
            let dataStok = res.data;
            let ready = 0;
            let gd_ready = "";
            let mata_uang = "";
            let campaign = "";
            let current_ready = 0;
            for (const key in dataStok) {
                if (key !== payload.items[0].comparator) continue
                mata_uang = dataStok[key].mata_uang;
                ready = dataStok[key].stok ? dataStok[key].stok : 0;
                gd_ready = dataStok[key].gudang;
                indent_whs = dataStok[key];

            }
            if (indent_whs.length) {
                ready = indent_whs[0].stok;
                gd_ready = indent_whs[0].gudang;

                setIndentWarehouses(indent_whs);
            }

            detail.forEach(datum => {
                /*console.log(datum);
                console.log(item);*/
                if (datum.itemno == item.ItemCode) {
                    if (datum.type == "Ready" && datum.gudang == gd_ready) {
                        current_ready += parseInt(datum.qty);
                    }
                }
            })

            // ditambah dengan current_ready dari pengajuan free item
            let current_ready_free = 0;
            listFreeDiskon.forEach(datum => {
                if (datum.item_id == item.ItemCode && datum.gudang == gd_ready) {
                    current_ready_free += parseInt(datum.qty);
                }
            });

            setState({
                ...state,
                showProduct: true,
                processing: false,
                opsiProductFree: {
                    itemname: item.ItemName,
                    itemno: item.ItemCode,
                    price: item.Price,
                    qty: ready > 0 ? 1 : 0,
                    mata_uang: mata_uang,
                    type: 'R',
                    paketid: campaign,
                    qty_ready: ready - current_ready - current_ready_free < 0 ? 0 : ready - current_ready - current_ready_free,
                    gudang_ready: gd_ready,
                    gudang_selected: gd_ready,
                    grade: 'A'
                }
            });
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        })
    };

    const createPOButtonText = () => {
        if (need_deduction && state.status !== "DEDUCTION" && state.status !== "PENDING DM" && state.status !== null) return "Continue";
        else if (state.status == "DEDUCTION") return "Submit Deduction";
        else return "Create Purchase Order";
    }

    const onQty = (e, value) => {
        setState({ ...state, qty_selected: e.target.value > value.kuota ? value.kuota : e.target.value });
    }

    const onUse = (value) => {
        if (value === undefined) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Please select a promo first!'
            });
            return;
        }
        let filteredArray = [];
        filteredArray = detail;
        const index = filteredArray.findIndex(e => e.id == state.listPromoSelected);
        if (index > -1) {
            startProcessing();
            let payload_detail = [
                {
                    itemcode: filteredArray[index].itemno,
                    qty: value.paketid?.substring(0, 4) == 'PREO' ? state.qty_selected : filteredArray[index].qty,
                    mi_kd_cmpg: value.paketid,
                    id: state.listPromoSelected,
                    whs: filteredArray[index].gudang,
                    action: "create"
                }
            ];
            const response_detail = createPODetail(state.order_no, payload_detail)
            response_detail.then(res => {
                let _po = res.data.PO;
                setAllHitungan(_po);
                $("#modal-promo").modal('hide');
            }).catch(({ response: { data } }) => {
                handlerFormError(data);
            }).finally(_ => stopProcessing());
        }

    }

    const onUseDiskon = (value, data) => {
        saveDiskon(value, data, 'create');
    }

    const rekomendasi_amountpkp = (saldo, nilai_order) => {
        //kalau saldo PKP > nilai order -> rekomendasi PKP = nilai order - 50rb
        //kalau saldo PKP < nilai order and selisih >= 50rb -> rekomendasi PKP = saldo PKP
        //kalau saldo PKP < nilai order and selisih < 50rb -> rekomendasi PKP = nilai order - 50rb
        let _rekomendasi_pkp = 0;
        let limit_pkp = 50000;
        let selisih = parseFloat(saldo) - parseFloat(nilai_order);
        if (parseFloat(saldo) > parseFloat(nilai_order)) {
            _rekomendasi_pkp = parseFloat(nilai_order) < limit_pkp ? parseFloat(nilai_order) : parseFloat(nilai_order) - limit_pkp;
        } else if (parseFloat(saldo) < parseFloat(nilai_order) && selisih >= limit_pkp) {
            _rekomendasi_pkp = parseFloat(saldo)
        } else if (parseFloat(saldo) < parseFloat(nilai_order) && selisih < limit_pkp) {
            _rekomendasi_pkp = parseFloat(nilai_order) - limit_pkp
        }

        if (_rekomendasi_pkp > saldo) {
            _rekomendasi_pkp = saldo;
        }

        return ParseDecimal(_rekomendasi_pkp);
    }

    const setAllHitungan = (_po) => {
        let arr_detail = [];
        let is_exist_sdfga = false;

        for (const key in _po.items) {
            let subtotal = (_po.items[key].totalbefdi * _po.items[key].qty);
            let net_disc = parseFloat(_po.items[key].m_disc_1) / 100;
            let campaign_disc = parseFloat(_po.items[key].m_disc_2) / 100;
            let prcntdisc = net_disc + ((1 - net_disc) * campaign_disc);
            let disc_total = subtotal * net_disc;
            //let am_ppn = parseFloat(_po.items[key].dpp * (_po.items[key].vatprcnt/100)).toFixed(2);

            if (_po.items[key].whs == "WH-SDFGA") {
                is_exist_sdfga = true;
            }

            arr_detail.push({
                grade: _po.items[key].grade,
                itemname: _po.items[key].dscription,
                itemno: _po.items[key].itemcode,
                price: _po.items[key].totalbefdi,
                qty: _po.items[key].qty,
                //type: "Ready",
                type: (_po.items[key].mi_kd_cmpg?.substring(0, 4) == 'PREO' ? "Indent" : "Ready"),
                paketid: _po.items[key].mi_kd_cmpg,
                paket_name: _po.items[key].mi_ket_cmpg,
                gudang: _po.items[key].whs,
                free: (_po.items[key].linetotal == 0 ? 1 : 0),
                id: _po.items[key].id,
                ppn: _po.items[key].vatprcnt,
                disc_item: parseFloat(_po.items[key].m_disc_2),
                net_disc: parseFloat(_po.items[key].m_disc_1),
                subtotal: subtotal - disc_total,
                linetotal: parseFloat(_po.items[key].linetotal),
                amount_dpp: parseFloat(_po.items[key].dpp),
                amount_ppn: parseFloat(_po.items[key].ppn),
                amount_discount: prcntdisc * subtotal,
                ppn_group: _po.items[key].vatgroup,
                additional_address: _po.items[key].additional_address,
                additional_receiver: _po.items[key].additional_receiver,
                additional_city: _po.items[key].additional_city,
                additional_county: _po.items[key].additional_county,
                additional_phone: _po.items[key].additional_phone,
                kirim_ambil: _po.items[key].kirim_ambil
            });
        }
        let hitungan = Calculate(arr_detail);
        let pkp = state.rekomendasi_pkp;
        if (state.status === 'DRAFT' && !need_deduction) {
            pkp = rekomendasi_amountpkp(pkp_amount, _po.doctotal)
        }

        // cek apakah ada _po.whs di _exclude_gudang
        let _exclude = listExcludeGudang.filter(item => item.code_name == userInfo.BPLName);
        let _listingTransitIndex = listTransitWhsCabang.findIndex(transit => {
            return transit.code_id === infoSupplier.U_M_BP_CODE_MI;
        });

        //cek apakah ada gudang di arr_detail
        let _gudang_exist_direct_customer = arr_detail.filter(item => item.gudang == listTransitWhsCabang[_listingTransitIndex]?.code_name);


        setTimeout(() => {
            setState({
                ...state,
                detail: arr_detail,
                grand_total: _po.doctotal,
                deduction: _po.discsum,
                total: hitungan.subtot,
                total_dpp: hitungan.amount_dpp,
                total_ppn: hitungan.amount_ppn,
                total_discount: hitungan.amount_disc,
                rekomendasi_pkp: pkp,
                show_direct_customer: _exclude.length > 0 && is_exist_sdfga || _gudang_exist_direct_customer.length > 0 ? true : false
            });
        }, 300);
    }

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }
    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    }

    const showDeduction = () => {
        if (listDiskon.length > 0) {
            setState({ ...state, modeDiskon: 'header', listFreeDiskon: [], show: true, posisi: 1 });
        }
    }

    const showDeductionEdit = (row, item) => {
        let value = {
            discount_id: row.diskonid,
            item_mode: row.item_mode
        }
        let data = {
            remark: row.diskon_keterangan,
            value: row.diskon,
            item_seq: item.item_seq
        }
        saveDiskon(value, data, 'edit')
    }

    const showDeductionItem = (item) => {
        if (listDiskon.length > 0) {
            setState({ ...state, modeDiskon: 'detail', listFreeDiskon: [], qty_selected: item.qty, show: true, item_seq_selected: item.item_seq_dm, item_no_selected: item.itemno });
        }
    }

    const closeModalDiskon = () => setState({ ...state, show: false, posisi: 0 });

    const processError = (message_obj) => {
        return message_obj['trans'] + "Error: " + JSON.parse(message_obj.response).error.message.value;
    }

    const submitPO = () => {
        if (state.so_number && !doc_entry_so && userInfo.BPLId > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Submission Failed',
                text: "Your sales order doesn't have Doc Number"
            })

            return;
        }
        if (state.detail.length > 0) {
            for (const key in state.detail) {
                if (state.detail[key].ppn == 12) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: 'PPN value cannot be 12!, <br/>please change the PPN value',
                    });
                    return;
                }

            }
        }
        if ((state.status == 'DRAFT' || state.status == "S" || state.status == "PENDING DM")) {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-modena',
                    cancelButton: 'btn btn-readonly mr-3'
                },
                buttonsStyling: false,
            })
            swalWithBootstrapButtons.fire(
                {
                    title: 'Confirmation',
                    text: 'Are You Sure Create Purchase Order ?',
                    confirmButtonColor: '#3085d6',
                    showCancelButton: true,
                    confirmButtonText: 'Sure',
                    reverseButtons: true
                }
            ).then(({ isConfirmed }) => {
                if (isConfirmed) {
                    //setState({ ...state, loading: true });
                    if ((state.verification_status === null || state.verification_status === false) && !state.so_number) {
                        updatePOHeader(state.order_no,
                            {
                                verification_status: null,
                                verified_remark: null,
                                verification_date: null,
                                verified_by: null,
                                status: "Waiting Verification",
                                need_deduction: need_deduction === true ? true : false,
                                direct_customer: direct_customer,
                            }).then(res => {
                                if (res.status == 200) {
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Submitted',
                                        text: "Purchase Order is submitted for verification!"
                                    }).then(() => {
                                        navigate('/purchaseorder')
                                    })
                                } else {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Submission Failed',
                                        text: "Please check your data and try again or contact support!"
                                    })
                                }
                            });
                    } else if (state.so_number) {
                        setState({ ...state, loading: true });
                        //PO dari SO tanpa verifikasi
                        const payload = {
                            pengajuan_diskon: need_deduction ? 1 : 0,
                            resubmit: 1,
                            direct_customer: direct_customer,
                        };
                        submitDM(state.order_id, payload, res => {
                            let iconSwal = 'success';
                            let messageSwal = res.data?.message;
                            if (messageSwal !== '') {
                                iconSwal = 'error';
                            }
                            Swal.fire({
                                icon: iconSwal,
                                title: iconSwal.toUpperCase(),
                                text: need_deduction ? 'Submit DM Success' : (messageSwal !== '' ? messageSwal : 'Update Purchase order success')
                            }).then(res => {
                                setState({ ...state, refresh: true, loading: false });
                            });
                        }, ({ response }) => {
                            let message = "";
                            let message_content = "";
                            if (Array.isArray(response.data.message)) {
                                message = processError(response.data.message[0]);
                            } else {
                                message = response.data.message;
                            }
                            Swal.fire({
                                icon: 'error',
                                title: need_deduction ? 'Submit DM Error' : 'Update Purchase Order Error',
                                text: message
                            });
                            if (response.data.items) {
                                let barang = response.data.items;
                                for (let i = 0; i < barang.length; i++) {
                                    message_content += `Items: ${barang[i]}`;
                                    if (i !== barang.length - 1) message_content += ", ";
                                }
                            }
                            setDMErrors({
                                type: message,
                                message: message_content
                            })
                        }).catch((error) => {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error ',
                                text: error
                            });
                        }).finally(() => {
                            setState({ ...state, loading: false });
                        });
                        //setState({...state, loading: false, refresh:true});
                    }


                }
            })

        } else if (state.status == "DEDUCTION") {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-modena',
                    cancelButton: 'btn btn-readonly mr-3'
                },
                buttonsStyling: false
            })
            swalWithBootstrapButtons.fire(
                {
                    title: 'Confirmation',
                    text: 'Are you sure Submit this Deduction ?',
                    confirmButtonColor: '#3085d6',
                    showCancelButton: true,
                    confirmButtonText: 'Sure',
                    reverseButtons: true
                }
            ).then(({ isConfirmed }) => {
                if (isConfirmed) {
                    const payload = {
                        order_id: order_no
                    };
                    setState({ ...state, loading: true });
                    submitDeduction(payload, res => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Submit Deduction success '
                        }).then(res => {
                            setState({ ...state, refresh: true });
                        });
                    }, ({ response }) => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Submit Deduction Error',
                            text: response.data.message
                        });
                    }).finally(() => {
                        setState({ ...state, loading: false });
                    });
                }
            })
        }
    }


    const onVerifyOrder = (status) => {
        setState({ ...state, loading: true });
        Swal.fire({
            title: 'Please enter a remark/message about the verification',
            input: 'textarea', // Specify the input type as "textarea"
            inputPlaceholder: 'Put remark here',
            allowOutsideClick: false,
            inputAttributes: {
                rows: 4, // Number of rows for the textarea
                required: true
            },
            showCancelButton: true,
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(), // Prevent closing during async work
        }).then(async (result) => {
            if (result.isConfirmed) {
                // The user confirmed, and you can access the textarea value
                const textarea_value = result.value;
                if (state.order_id !== null && state.order_id !== "") {
                    const params = {
                        verification_status: status == "R" ? true : false,
                        verification_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                        verified_by: userInfo.user_fullname,
                        verified_remark: textarea_value,
                        direct_customer: direct_customer,
                    }
                    if (status == "N") params.status = "DRAFT";
                    const response_so_update = await updatePOHeader(state.order_no, params);
                    if (response_so_update.status == 200) {
                        //Swal.fire({
                        //icon: 'success',
                        //title: 'Verification success!'
                        //}).then(() => {
                        //setState({...state, loading:true})

                        if (status == "R") {
                            const payload = {
                                pengajuan_diskon: need_deduction ? 1 : 0,
                                resubmit: 1
                            };
                            submitDM(state.order_id, payload, res => {
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Success',
                                    text: "Purchase Order Verification Success"
                                    //text: need_deduction ? 'Submit DM Success' : 'Update Purchase order success '
                                }).then(res => {
                                    setState({ ...state, refresh: true, loading: false });
                                });
                            }, ({ response }) => {
                                let message = "";
                                let message_content = "";
                                if (Array.isArray(response.data.message)) {
                                    message = processError(response.data.message[0]);
                                } else {
                                    message = response.data.message;
                                }
                                Swal.fire({
                                    icon: 'error',
                                    title: "Verification failed",
                                    //title: need_deduction ? 'Submit DM Error' : 'Update Purchase Order Error',
                                    text: message
                                });
                                if (response.data.items) {
                                    let barang = response.data.items;
                                    for (let i = 0; i < barang.length; i++) {
                                        message_content += `Items: ${barang[i]}`;
                                        if (i !== barang.length - 1) message_content += ", ";
                                    }
                                }
                                setDMErrors({
                                    type: message,
                                    message: message_content
                                })
                            }).catch((error) => {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Error ',
                                    text: error
                                });
                            }).finally(() => {
                                setState({ ...state, loading: false, refresh: true });
                            });
                        } else setState({ ...state, loading: false, refresh: true })
                        // });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Verification failed!',
                            text: "Please try again or contact support!"
                        })

                    }
                }
            } else {
                setState({ ...state, loading: false });
            }
        });
    }


    let doc_entry_so = useMemo(() => {
        return extra_so_data.DocNum
    }, [extra_so_data]);

    useEffect(() => {
        console.log(state.loading)
    }, [state.loading]);

    const [statePreorder, setStatePreorder] = useState([]);
    const [statePreorderDetail, setStatePreorderDetail] = useState({});
    const getPreorderCampaign = async (itemDetail) => {
        setStatePreorderDetail({});
        document.querySelector('#modal-product-detail').style.display = 'none';
        document.querySelector('#modal-product-preorder').style.display = 'block';
        let payload = {
            order_id: state.order_no,
            dealer_id: infoSupplier.U_M_BP_CODE_MI,
            item_id: itemDetail.itemno,
            gudang_cabang: itemDetail.gudang
        }
        const res = await getPromoMIPreo(payload)
        if (res.status === 200) {
            setStatePreorder(res.data);
        }
    }

    const backFromPreorderCampaign = () => {
        document.querySelector('#modal-product-detail').style.display = 'block';
        document.querySelector('#modal-product-preorder').style.display = 'none';
    }

    const detailPreorderCampaign = async (campaign, item_id, dealer_id) => {
        let payload = {
            order_id: state.order_no,
            dealer_id: dealer_id,
            gudang_cabang: "WH-JTFGA",
            item_id: item_id
        }
        const res = await getPromoMIPreo(payload);
        if (res.status === 200) {
            res.data.filter(datum => {
                if (datum.paketid === campaign) {
                    let _kuota_terpakai = kuota_terpakai(campaign, item_id);
                    datum.kuota -= _kuota_terpakai;
                    setStatePreorderDetail(datum);
                    setStatePreorderQty(1);
                }
            })
        }
    }

    const kuota_terpakai = (campaign, item_id) => {
        let qty = 0;
        detail.forEach(datum => {
            if (datum.itemno == item_id && datum.paketid == campaign) {
                qty += parseInt(datum.qty);
            }
        })
        return qty
    }

    const [statePreorderQty, setStatePreorderQty] = useState(1);
    const onChangeQtyPreorder = (e, kuota) => {
        setStatePreorderQty(e.target.value < 1 ? 1 : (e.target.value > kuota ? kuota : e.target.value));
    }

    const addProductDetailPreorder = (item, statePreorderDetail) => {
        let payload = {
            itemno: item.itemno,
            qty: statePreorderQty,
            type: 'Indent',
            grade: 'A',
            gudang_selected: 'GDGPRO',
            paketid: statePreorderDetail.paketid,
        }
        addProductDetail(payload);
        document.querySelector('#modal-product-preorder').style.display = 'none';
        document.querySelector('#modal-product-detail').style.display = 'block';
    }

    const propsTableProduct = { columns: columns_product, getData: getListProduk, showIndex: true, searchBarWidth: "9" };
    const propsTableProductFree = { columns: columns_product_free, getData: getListProduk, showIndex: true };
    const propsPrint = { getState: state, login: userInfo }
    return (
        <div className="content-wrapper">
            <Overlay display={state.loading} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-12">
                            <h2 className="title-breadcrum">
                                {pageState == 'create' ? 'Create Purchase Order' : 'Purchase Order #' + state.order_no} &nbsp;

                                {state.status == 'Reject' ?
                                    <span className="badge bg-red me-2">Reject</span>
                                    : state.status == 'COMPLETED' ?
                                        <span className="badge bg-paid me-2">COMPLETED</span>
                                        : state.status == 'DEDUCTION' ?
                                            <span className="badge bg-teal me-2">Deduction</span>
                                            : state.status == 'SUBMITTED' ?
                                                <>
                                                    <span className="badge bg-close me-2">SUBMITTED</span>
                                                </>

                                                : (state.status == 'Waiting Verification') ?
                                                    <>
                                                        {userInfo.role_name !== "SO Payment Verificator" && <span className="badge bg-teal" style={{ width: "150px" }}>Waiting Verification </span>}
                                                        {userInfo.role_name == "SO Payment Verificator" && <span className="badge bg-teal me-2">Not Verified</span>}
                                                    </>
                                                    : (state.status == 'S' || state.status == 'DRAFT') ?
                                                        <>
                                                            {state.verification_status === null && userInfo.role_name !== "SO Payment Verificator" && <span className="badge bg-draft me-2">DRAFT</span>}
                                                            {state.verification_status === null && userInfo.role_name == "SO Payment Verificator" && <span className="badge bg-teal me-2">Not Verified</span>}
                                                            {state.verification_status === false && <span className="badge badge-danger">Verification Reject</span>}
                                                            {state.verification_status === true && userInfo.role_name == "SO Payment Verificator" && <span className="badge bg-paid me-2">Submitted</span>}
                                                        </>

                                                        : state.status == 'PENDING DM' ?
                                                            <span className="badge bg-khaki me-2">PENDING DM</span>
                                                            : state.status == 'Open' ?
                                                                <span className="badge bg-cyan me-2">Open</span>
                                                                : state.status == 'WAITING APPROVAL' ?
                                                                    <span className="badge bg-chartreuse me-2">WAITING APPROVAL</span>
                                                                    : state.status == 'CANCELED' ?
                                                                        <span className="badge bg-red me-2">CANCELED</span> : ''
                                }

                                {state.order_no != "" && state.order_no &&
                                    <>
                                        <div style={{ display: 'none' }}>
                                            <PrintPO ref={componentRef} {...propsPrint} />
                                        </div>
                                        <div style={{ float: 'right', cursor: 'pointer' }}>
                                            <img src={print} onClick={handlePrint} />
                                        </div>
                                    </>
                                }
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className='shadow' style={{ marginBottom: 20 }}>
                        <div className='row'>
                            <div className='col-sm-4' style={{ paddingRight: 0 }}>
                                <div className="card">
                                    <div className="card-header py-3 bg-white">
                                        <h6 className="m-0 title-breadcrum tx-gray" >
                                            Info Supplier
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className='row' style={{ padding: '10px 25px' }}>
                                            <div className='col-sm-12'>
                                                <MInput
                                                    name='name'
                                                    label='Name/ID'
                                                    type='text'
                                                    icon={<i className="bi bi-people"></i>}
                                                    readOnly
                                                    defaultValue={infoSupplier.nama_supplier}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className='row' style={{ padding: '10px 25px' }}>
                                            <div className='col-sm-12'>
                                                <MInput
                                                    id='required_date'
                                                    name='required_date'
                                                    label='Required Date'
                                                    type='date'
                                                    value={infoSupplier.required_date}
                                                    icon={<i className="bi bi-calendar3"></i>}
                                                    required
                                                    readOnly={locked}
                                                    onChange={onDateDeliveryChange}
                                                />
                                            </div>
                                        </div>
                                        <div className='row' style={{ padding: '10px 25px' }}>
                                            <div className='col-sm-12'>
                                                <MInput
                                                    name='so_number'
                                                    label='SO Number'
                                                    type='text'
                                                    icon={<i className="bi bi-phone"></i>}
                                                    readOnly
                                                    defaultValue={state.so_number}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-8' style={{ paddingLeft: 0 }}>
                                <div className="card">
                                    <div className="card-header py-3 bg-white">
                                        <h6 className="m-0 title-breadcrum tx-gray" >
                                            Info Customer
                                        </h6>
                                    </div>
                                    <div className="card-body">

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className='row' style={{ padding: '10px 25px' }}>
                                                    <div className='col-sm-12'>
                                                        <MInput
                                                            id='nama_customer'
                                                            name='nama_customer'
                                                            label='Name/ID'
                                                            type='text'
                                                            disabled={true}
                                                            defaultValue={state.shipping_name}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row' style={{ padding: '10px 25px' }}>
                                                    <div className='col-sm-6'>
                                                        <MSelect label='NPWP'
                                                            options={listNpwp}
                                                            value={npwp.lineID}
                                                            onChange={(e) => onChangeNPWP(e)}
                                                            disabled={locked}
                                                        />
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <MSelect label='Address'
                                                            options={listAddress}
                                                            value={address_code.value}
                                                            onChange={(e) => onChangeAddressCode(e)}
                                                            disabled={locked}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row' style={{ padding: '11px 25px' }}>
                                                    <div className='col-sm-12'>
                                                        <MSelect label='Order Type'
                                                            options={listordertype}
                                                            value={m_tp_penj}
                                                            onChange={(e) => onChangeOrderType(e)}
                                                            disabled={locked}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className='row'>
                                                    <div className='row' style={{ padding: '10px 25px' }}>
                                                        <div className='col-sm-12'>
                                                            <h4 style={{ fontSize: 18 }}>NPWP</h4>
                                                        </div>
                                                        <div className='col-sm-12'>
                                                            <ul style={{ marginBottom: 0, paddingInlineStart: 20 }}>
                                                                <li style={{ fontSize: 14, fontWeight: 600 }}>{npwp ? npwp.custName : "-"}</li>
                                                                <li style={{ fontSize: 14 }}>{npwp ? npwp.custAddr : "-"}</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className='row' style={{ padding: '10px 25px' }}>
                                                        <div className='col-sm-12'>
                                                            <h4 style={{ fontSize: 18 }}>Address</h4>
                                                        </div>
                                                        <div className='col-sm-12'>
                                                            <ul style={{ marginBottom: 0, paddingInlineStart: 20 }}>
                                                                <li style={{ fontSize: 14, fontWeight: 600 }}>{state.shipping_name}</li>
                                                                <li style={{ fontSize: 14 }}>{state.shipping_address}</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {detail && detail.length > 0 &&
                        <>
                            <div className="card shadow mb-4">
                                <div className="card-header py-3 bg-white">
                                    <div className='row'>
                                        <div className='col-sm-8'>
                                            <h6 className="m-0 title-breadcrum tx-gray" >Detail Product</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {dm_errors.message &&
                                        <div className="dm-error-message">
                                            <h5 className='bold black'>{dm_errors.type}</h5>
                                            <p>{dm_errors.message}</p>
                                        </div>
                                    }
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="dataTable" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th className='th-no-border'>No</th>
                                                    <th className='th-no-border'>Product</th>
                                                    <th className='th-no-border'>Warehouse</th>
                                                    <th className='th-no-border'>Qty</th>
                                                    <th className='th-no-border'>Stok</th>
                                                    <th className='th-no-border'>Currency</th>
                                                    <th className='th-no-border' style={{ textAlign: 'right' }}>Price / Unit</th>
                                                    <th className='th-no-border'>Net / Disc</th>
                                                    <th className='th-no-border'>PPN</th>
                                                    <th className='th-no-border'>Price</th>
                                                    {so_number && so_number !== "" && <th className='th-no-border'>Additional Address</th>}
                                                    <th className='th-no-border'></th>
                                                    {so_number == "" && <th className='th-no-border'></th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {detail.map((row, index) => (
                                                    <>
                                                        <tr key={`tr-` + index} >

                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <label style={{ textAlign: 'left', display: 'block' }}>{row.itemname} ({row.itemno})</label><br />
                                                                {
                                                                    state.m_tp_penj === 'PMR' && row.gudang === userInfo.kode_gudang_pameran_a &&
                                                                    <>
                                                                        <input className="form-check-input" id={'cbKirimAmbil' + index} type='checkbox'
                                                                            checked={row.kirim_ambil == 1}
                                                                            onChange={(e) => setKirimAmbilChecked(e, index, row.id)}
                                                                            disabled={(state.status != "DRAFT")}
                                                                        />
                                                                        <label for={'cbKirimAmbil' + index} style={{ textAlign: 'left', display: 'block' }}>Customer self pick up</label>
                                                                    </>
                                                                }
                                                            </td>
                                                            <td>
                                                                <label style={{ textAlign: 'center', display: 'block' }}>{row.gudang}</label>
                                                            </td>
                                                            <td width={60}>
                                                                <label style={{ textAlign: 'center', display: 'block' }}>{row.qty}</label>
                                                            </td>
                                                            <td width={50}>
                                                                <label style={{ color: row.type == 'Indent' ? 'rgb(190, 74, 49)' : '#858796' }}>{row.type}</label>
                                                            </td>
                                                            <td width={50}>
                                                                <label>IDR</label>
                                                            </td>
                                                            <td width={150} style={{ textAlign: 'right' }}>
                                                                <label> {NumberFormat(row.price)}</label>
                                                            </td>
                                                            <td width={80}>
                                                                <label>{row.net_disc}%</label>
                                                            </td>
                                                            <td width={120}>
                                                                <select className='form-control ps-0' style={{ width: 80 }} onChange={(e) => onChangePPN(e, row)} disabled={(userInfo.role_name == "SO Payment Verificator" || state.status == "Waiting Verification")}>
                                                                    {
                                                                        listppn?.map((_ppn, i) => (<option key={`ppn-` + i} data-ppn-code={_ppn.Code} value={parseFloat(_ppn.Rate)} selected={row.ppn == parseInt(_ppn.Rate)}>{NumberFormat(_ppn.Rate)}%</option>))
                                                                    }
                                                                </select>
                                                            </td>
                                                            <td style={{ paddingRight: 0, textAlign: 'right' }}>{NumberFormat(row.subtotal)}</td>

                                                            {so_number && so_number !== "" && <td> {!row.additional_address && ""}
                                                                {row.additional_address && row.additional_address != "" &&
                                                                    <div style={{ display: "flex" }}>
                                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                                            <div style={{ fontWeight: "700" }}>{row.additional_receiver}</div>
                                                                            <div style={{ wordWrap: "break-word" }}>
                                                                                {row.additional_address},
                                                                                {row.additional_city},&nbsp;{row.additional_county}
                                                                            </div>
                                                                            <div>
                                                                                {row.additional_phone}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }</td>}
                                                            <td>
                                                                {row.free == 0 && state.locked_promo == false && (row.paketid == null || row.paketid == "") &&
                                                                    <div>
                                                                        <button onClick={() => promo(row)} className="btn btn-outline-warning" style={{ border: 'dotted', width: 100 }} type="button" disabled={(userInfo.role_name == "SO Payment Verificator" || state.status == "Waiting Verification")}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tags-fill" viewBox="0 0 16 16">
                                                                                <path d="M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
                                                                                <path d="M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043-7.457-7.457z" />
                                                                            </svg>&nbsp;Promo
                                                                        </button>
                                                                    </div>
                                                                }
                                                                {row.free == 0 && state.locked_promo == false && (row.paketid !== null && row.paketid !== "" && row.paketid.substring(0, 4) !== 'PREO') &&
                                                                    <div>
                                                                        <Button
                                                                            loading={state.processing}
                                                                            onClick={() => cancelpromo(row)}
                                                                            severity="danger"
                                                                            className="btn btn-outline-danger"
                                                                            style={{ border: 'dotted', width: 100, background: 'transparent', color: '#e74a3b', borderColor: '#e74a3b' }}
                                                                            disabled={(userInfo.role_name == "SO Payment Verificator" || state.status == "Waiting Verification")}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tags-fill" viewBox="0 0 16 16">
                                                                                <path d="M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
                                                                                <path d="M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043-7.457-7.457z" />
                                                                            </svg>&nbsp;Cancel
                                                                        </Button>
                                                                    </div>
                                                                }
                                                                {state.status == 'DEDUCTION' && row.item_seq_dm_asal == null && row.linetotal > 0 && !row.mi_add_disc &&
                                                                    <div>
                                                                        <button disabled={(listDiskon.length == 0 || userInfo.role_name == "SO Payment Verificator" || state.status == "Waiting Verification")}
                                                                            onClick={() => showDeductionItem(row)}
                                                                            className="btn btn-outline-warning" style={{ border: 'dotted', width: 100 }} type="button">
                                                                            Add Disc
                                                                        </button>
                                                                    </div>
                                                                }
                                                            </td>
                                                            {!so_number &&
                                                                <td>
                                                                    {row.free == 0 && locked == false && userInfo.role_name !== "SO Payment Verificator" && state.status != "Waiting Verification" &&
                                                                        <div style={{ border: 2, cursor: 'pointer' }} onClick={() => onRemoveProduct(row)}>
                                                                            <img src={trash} />
                                                                        </div>
                                                                    }
                                                                </td>
                                                            }
                                                        </tr>
                                                        {row.paketid &&
                                                            <>
                                                                <tr key={`tr-` + index}>
                                                                    <td colSpan={4}></td>
                                                                    <td colSpan={4} style={{ fontSize: 14, padding: 0, textAlign: 'right' }}>{row.paket_name}</td>
                                                                    <td style={{ padding: 0, textAlign: 'right' }}>{NumberFormat(row.disc_item)}%</td>
                                                                    <td colSpan={2}></td>
                                                                </tr>
                                                                {(row.mi_add_disc == null || row.mi_add_disc == "") &&
                                                                    <tr>
                                                                        <td colSpan={4}></td>
                                                                        <td colSpan={4} style={{ fontSize: 14, padding: 0, fontWeight: 700, textAlign: 'right' }}>Final Price</td>
                                                                        <td style={{ padding: 0, textAlign: 'right' }}>{NumberFormat(row.linetotal)}</td>
                                                                        <td colSpan={2}></td>
                                                                    </tr>
                                                                }
                                                            </>
                                                        }
                                                        {row.mi_add_disc != null && row.mi_add_disc != "" &&
                                                            <>
                                                                <tr key={`tr-` + index}>
                                                                    <td colSpan={5}></td>
                                                                    <td colSpan={3} style={{ fontSize: 14, padding: 0, textAlign: 'right' }}>{row.mi_ket_add_disc} ({row.mi_add_disc})</td>
                                                                    <td style={{ padding: 0, textAlign: 'right' }}>{NumberFormat(row.m_disc_3)}%</td>
                                                                    <td colSpan={2}></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={5}></td>
                                                                    <td colSpan={3} style={{ fontSize: 14, padding: 0, fontWeight: 700, textAlign: 'right' }}>Final Price</td>
                                                                    <td style={{ padding: 0, textAlign: 'right' }}>{NumberFormat(row.linetotal)}</td>
                                                                    <td colSpan={2}></td>
                                                                </tr>
                                                            </>
                                                        }
                                                    </>
                                                ))}
                                            </tbody>
                                        </table>

                                    </div>
                                    {!so_number && !locked && !includes(userInfo.role_name, "MHC Dealer") &&
                                        <div className='row d-flex align-items-center justify-content-center' style={{ marginBottom: 30 }}>
                                            <button className="btn btn-outline-primary" style={{ border: 'none', width: 200 }} type="button" onClick={addProduct}>
                                                <span className='fas fa-plus'></span> Add Product
                                            </button>
                                        </div>
                                    }
                                    <div className='row' style={{ marginBottom: 50 }}>

                                        <div className='col-sm-7'>
                                            {appliedAdditionalDiscount && appliedAdditionalDiscount.length > 0 &&
                                                <>
                                                    <h2 className='title-promo'>LIST ADDITIONAL DISCOUNT</h2>
                                                    <div className='d-flex diskon' style={{ marginBottom: 20 }}>
                                                        <ul style={{ width: '100%' }}>
                                                            {appliedAdditionalDiscount.map((row, index) => (
                                                                <li>
                                                                    <div className='row'>
                                                                        <div className='col-11'>
                                                                            <h5>{row.diskon_label}</h5>
                                                                        </div>
                                                                        <div className='col-1'>
                                                                            {state.status == 'DEDUCTION' && state.status !== "Waiting Verification" &&
                                                                                <div style={{ border: 2, cursor: 'pointer' }} onClick={() => hapusDiskon(row)}>
                                                                                    <img src={trash} />
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                    <table className='table list-diskon'>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>Keterangan</td>
                                                                                <td>:</td>
                                                                                <td>
                                                                                    <p style={{ marginBottom: 0 }}>{row.diskon_label_keterangan}</p>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Diskon</td>
                                                                                <td>:</td>
                                                                                <td>{row.diskon}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Persetujuan</td>
                                                                                <td>:</td>
                                                                                <td>
                                                                                    {row.persetujuan_melalui.length > 0 &&
                                                                                        <table className='table table-bordered'>
                                                                                            <thead style={{ backgroundColor: 'gray', color: '#fff' }}>
                                                                                                <tr>
                                                                                                    <th>Melalui</th>
                                                                                                    <th>Status Persetujuan</th>
                                                                                                    <th>Tanggal</th>
                                                                                                    <th>Keterangan</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {row.persetujuan_melalui.map((item, i) => (
                                                                                                    <tr>
                                                                                                        <td>{item.persetujuan_melalui}</td>
                                                                                                        <td>{item.status_persetujuan}</td>
                                                                                                        <td>{item.tanggal_persetujuan}</td>
                                                                                                        <td>{item.keterangan_persetujuan}</td>
                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>Remark</td>
                                                                                <td>:</td>
                                                                                <td>{row.diskon_keterangan}</td>
                                                                            </tr>
                                                                            {row.url_lampiran &&
                                                                                <tr>
                                                                                    <td colSpan={3}>
                                                                                        <div className='mb-4' >
                                                                                            <img src={row.url_lampiran} className='img-responsive' style={{ width: 160, height: 160 }} />
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            }
                                                                            {row.items &&
                                                                                <tr>
                                                                                    <td>Items</td>
                                                                                    <td>:</td>
                                                                                    <td>
                                                                                        <table className='table table-bordered'>
                                                                                            <thead style={{ backgroundColor: 'gray', color: '#fff' }}>
                                                                                                <tr>
                                                                                                    <th>Item Name</th>
                                                                                                    <th>Qty</th>
                                                                                                    <th></th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {row.items.map((item, i) => (
                                                                                                    <tr>
                                                                                                        <td>{item.nama_item}</td>
                                                                                                        <td>{item.kuantitas}</td>
                                                                                                        <td style={{ textAlign: 'center' }}>
                                                                                                            {state.status == 'DEDUCTION' &&
                                                                                                                <span className='fa fa-times' style={{ color: 'red', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => showDeductionEdit(row, item)}></span>
                                                                                                            }
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>

                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </>
                                            }
                                            <div style={{ border: "1px solid black", padding: "8px" }}>
                                                <h6 className='black'>Sales Remark</h6>
                                                <textarea onBlur={() => updatePOHeader(state.order_no, { sales_remark: state.sales_remark })} style={{ width: "100%", height: "200px" }} value={state.sales_remark} onChange={(e) => setState({ ...state, sales_remark: e.target.value })} disabled={disableRemark(state.status, userInfo.role_name)}></textarea>
                                            </div>
                                        </div>
                                        <div className='col-sm-5'>
                                            {/*state.status !== "SUBMITTED" && state.status !== "COMPLETED" &&
                                        <>
                                            <h2 className='title-promo'>PROMO CODE</h2>
                                            <div className='d-flex align-items-center justify-content-center promo' onClick={applyPromo} style={{marginBottom: 20}}>
                                                APPLY PROMO / CAMPAIGN
                                            </div>
                                        </>
                                */}
                                            {state.status == 'DEDUCTION' &&
                                                <button className="btn btn-primary btn-block" disabled={listDiskon.length == 0} style={{ backgroundColor: '#BE4A31', marginTop: "30px", marginBottom: 30 }} type="button" onClick={showDeduction}>
                                                    Additional Deduction
                                                </button>
                                            }

                                            <h1 className='title-promo' style={{ fontSize: "16px" }}>Detail Price</h1>
                                            <div className='row'>
                                                <div className='col-sm-6 mb-2'>Total Before Discount</div>
                                                <div className='col-sm-6 text-right'>{NumberFormat(total)}</div>
                                                <div className='col-sm-6 mb-2' style={{ color: '#BE4A31' }}>Discount</div>
                                                {/*<div className='col-sm-6 text-right' style={{color: '#BE4A31'}}>{NumberFormat(total_discount)}</div>*/}
                                                <div className='col-sm-6 text-right' style={{ color: '#BE4A31' }}>{NumberFormat(total - Math.round(ParseDecimal(Math.abs(grand_total))))}</div>
                                                {deduction > 0 &&
                                                    <>
                                                        <div className='col-sm-6 mb-2' style={{ color: '#BE4A31' }}>Additional Discount</div>
                                                        <div className='col-sm-6 text-right' style={{ color: '#BE4A31' }}>- {NumberFormat(deduction)}</div>
                                                    </>
                                                }

                                                <div className='col-sm-6 mb-2'>Total</div>
                                                {/*<div className='col-sm-6 text-right'>{NumberFormat(total-deduction-total_discount)}</div>*/}
                                                <div className='col-sm-6 text-right'>{NumberFormat(Math.round(ParseDecimal(Math.abs(grand_total))))}</div>
                                                <div className='col-sm-6 mb-2'>DPP</div>
                                                <div className='col-sm-6 text-right'>{(userInfo.u_m_pkp == "Y" || includes(userInfo.role_name, "MHC Dealer")) ? NumberFormat(Math.round(ParseDecimal(total_dpp))) : 0}</div>
                                                <div className='col-sm-6 mb-2'>PPN</div>
                                                <div className='col-sm-6 text-right'>{(userInfo.u_m_pkp == "Y" || includes(userInfo.role_name, "MHC Dealer")) ? NumberFormat(Math.round(total_ppn)) : 0}</div>
                                                <div className='col-sm-6 mb-2'>NON PPN</div>
                                                <div className='col-sm-6 text-right'>{(userInfo.u_m_pkp == "Y" || includes(userInfo.role_name, "MHC Dealer")) ? NumberFormat(Math.round(ParseDecimal(Math.abs(grand_total - total_dpp - total_ppn)))) : NumberFormat(Math.round(ParseDecimal(Math.abs(grand_total))))}</div>
                                                {rekomendasi_pkp > 0 &&
                                                    <>
                                                        <div className='col-sm-6 mb-2' style={{ color: '#BE4A31' }}>PKP</div>
                                                        <div className='col-sm-6 text-right' style={{ color: '#BE4A31' }}>- {NumberFormat(rekomendasi_pkp)}</div>
                                                    </>
                                                }
                                                <div className='col-sm-6 grand-total' >Grand Total</div>
                                                <div className='col-sm-6 text-right grand-total'>{NumberFormat(ParseDecimal(grand_total - rekomendasi_pkp))}</div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className='d-flex align-items-center'>
                                                <div className="form-check" style={{ marginLeft: 20 }}>
                                                    <input className="form-check-input" id="flexCheckDefault" type="checkbox" checked={applypkp === true} onChange={onChangeApplyPKP} disabled={(disabled_pkp || userInfo.role_name == "SO Payment Verificator") || state.status == "Waiting Verification"} />
                                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                                        APPLY PKP<br />
                                                        <span style={{ color: 'green' }}>({NumberFormat(pkp_amount)})</span>
                                                    </label>
                                                </div>
                                                <CurrencyInput
                                                    className='form-control ps-0'
                                                    decimalSeparator=","
                                                    groupSeparator="."
                                                    decimalsLimit={0}
                                                    allowNegativeValue={false}
                                                    style={{ width: 200, marginLeft: 10, textAlign: 'right' }}
                                                    onValueChange={onEditableChange}
                                                    value={rekomendasi_pkp}
                                                    disabled={!applypkp || (state.status == 'DEDUCTION' ? false : locked)}
                                                    placeholder="0" />
                                            </div>
                                        </div>
                                        <div className='col-md-4'></div>
                                        {((state.show_direct_customer || state.direct_customer) &&
                                            <div className='col-md-5'>
                                                <div className='row' style={{ justifyContent: 'flex-end', marginRight: 20, paddingBottom: 10 }}>

                                                    <div className="form-check" >

                                                        <input className="form-check-input" id="flexCheckDefault2" type="checkbox"
                                                            checked={direct_customer} onChange={onChangeApplyDirectCustomer}
                                                            disabled={locked_promo} />
                                                        <label className="form-check-label" style={{ marginLeft: 20 }} htmlFor="flexCheckDefault2">
                                                            DELIVERY DIRECT TO CUSTOMER
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                        )}
                                    </div>
                                </div>
                            </div>

                            {(state.status === "DRAFT" || state.status === "PENDING DM" || state.status == "Waiting Verification") &&
                                <div className='row' style={{ justifyContent: 'flex-end', marginRight: 20, paddingBottom: 10 }}>

                                    <div className="form-check" >
                                        <label className="form-check-label" htmlFor="need_deduction">
                                            Need Additional Deduction ?
                                        </label>
                                        <input className="form-check-input" id="need_deduction" type="checkbox" checked={need_deduction} onChange={onChangeNeedDeduction} style={{ marginLeft: 10 }} disabled={(disabled_deduction || userInfo.role_name == "SO Payment Verificator" || state.status == "Waiting Verification")} />
                                    </div>
                                </div>
                            }
                            {userInfo.role_name !== "SO Payment Verificator" && <div className='row' style={{ justifyContent: 'flex-end' }}>

                                <div className='col-sm-2'>
                                    <Link to="/purchaseorder" className='btn btn-readonly btn-block' style={{ marginBottom: 30 }}>Back</Link>
                                </div>
                                {(state.status == "SUBMITTED" || state.status == "COMPLETED") &&
                                    <div className='col-sm-3'>
                                        <button className="btn btn-modena btn-block" style={{ marginBottom: 30, backgroundColor: "#FA9C1B" }} type="button" onClick={() => {
                                            window.open(`https://dm.modena.com/__email.php?order_id=${id_po}`, "_blank");
                                        }}>
                                            Resend DM Mail
                                        </button>
                                    </div>
                                }
                                {state.status !== "SUBMITTED" && state.status !== "COMPLETED" && state.status !== 'WAITING APPROVAL' && state.status !== 'CANCELED' && state.status !== 'PENDING DM' && state.status !== "Waiting Verification" &&
                                    <div className='col-sm-3'>
                                        <button className="btn btn-modena btn-block" style={{ marginBottom: 30 }} type="button" onClick={submitPO}>
                                            {createPOButtonText()}
                                        </button>
                                    </div>
                                }
                            </div>}

                            {userInfo.role_name == "SO Payment Verificator" && state.verification_status !== null && state.verification_status === true &&
                                <div style={{ padding: 10, background: '#ffeecf' }}>
                                    <div style={{ marginBottom: 0, marginTop: 5, fontWeight: 'bold', fontSize: 18 }}>Informasi Approval : </div>
                                    <h4 style={{ fontStyle: 'italic', fontSize: 21, color: 'rgb(255, 168, 0)', fontWeight: 500 }}>
                                        - Sudah di approve pada tanggal {moment(state.verification_date).format('DD MMM YYYY HH:mm:ss')}
                                        <br />
                                        - Catatan : {state.verified_remark}
                                    </h4>
                                </div>
                            }

                            {userInfo.role_name == "SO Payment Verificator" && state.verification_status !== null && state.verification_status === false &&
                                <div style={{ padding: 10, background: '#f71a1a21' }}>
                                    <div style={{ marginBottom: 0, marginTop: 5, fontWeight: 'bold', fontSize: 18 }}>Informasi Reject : </div>
                                    <h4 style={{ fontStyle: 'italic', fontSize: 21, color: 'red', fontWeight: 500 }}>
                                        - Sudah di reject pada tanggal {moment(state.verification_date).format('DD MMM YYYY HH:mm:ss')}<br />
                                        - Catatan : {state.verified_remark}
                                    </h4>
                                </div>
                            }

                            {userInfo.role_name == "SO Payment Verificator" && state.verification_status === null && state.status === "Waiting Verification" &&
                                <div style={{ display: "flex", columnGap: "10px", justifyContent: "flex-end", marginTop: "10px" }}>
                                    <div>
                                        <button className="btn btn-danger btn-block" style={{ marginBottom: 30 }} type="button" onClick={() => onVerifyOrder("N")}>
                                            Reject Order
                                        </button>
                                    </div>
                                    <div>
                                        <button className="btn btn-success btn-block" style={{ marginBottom: 30 }} type="button" onClick={() => onVerifyOrder("R")}>
                                            Approve Order
                                        </button>
                                    </div>
                                </div>
                            }
                        </>
                    }
                    {detail.length <= 0 &&
                        <div className='row d-block' style={{ margin: "0 1px" }}>
                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className='row d-flex align-items-center justify-content-center'>
                                        {!includes(userInfo.role_name, "MHC Dealer") && userInfo.role_name !== "SO Payment Verificator" && !includes(userInfo.role_name, "MHC Owner") && <h6>It seems there's no products here yet. You can click the button below to get started..</h6>}                              </div>
                                    <div className='row d-flex align-items-center justify-content-center' style={{ paddingTop: "10px", marginBottom: "1rem !important" }}>
                                        {/*<h5 style={{fontWeight:"700"}}>Please create the Purchase Order through Indent Sales Order</h5>*/}
                                        {userInfo.role_name !== "SO Payment Verificator" && !includes(userInfo.role_name, "MHC Dealer") && !includes(userInfo.role_name, "MHC Owner") && <button className="btn btn-dark" type="button" onClick={addProduct}>
                                            <span className='fas fa-plus'></span> Add Product
                                        </button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <Modal id="modal-promo">
                        <Overlay display={state.processing} />
                        <ModalPromoPO listPromo={listPromo} onHandleClick={onUse} qty={state.qty_selected} onChangeQty={onQty} kuota={state.kuota_default} />
                    </Modal>
                    <Modal id="modal-promo-header">
                        <Overlay display={state.processing} />
                        <ModalPromoPO listPromo={listPromo} withCode={true} onHandleClick={onUse} />
                    </Modal>
                    <Modal id="modal-deduction" >
                        <Overlay display={state.processing} />
                        <ModalDiskonPO
                            listDiskon={listDiskon}
                            onHandleClick={onUseDiskon}
                            mode={modeDiskon}
                            onBrowseItems={addProductFree}
                            listFreeDiskon={listFreeDiskon}
                            posisi={1}
                            qty={state.qty_selected}
                            show={show}
                            closeModalDiskon={closeModalDiskon}
                        />
                    </Modal>
                    <div id="modal-product" className='modal'>
                        <form name="form-product">
                            <div className='modal-dialog modal-dialog-centered modal-xl'>
                                <div className='modal-content'>
                                    <div className='modal-header'>
                                        <h5 className="modal-title"> Product List</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className='modal-body'>
                                        <div className="row">
                                            <div className='col-sm-8'>
                                                <MTable ref={mTableP} {...propsTableProduct} />
                                            </div>
                                            <div className='col-sm-4'>
                                                <Overlay display={state.processing} />
                                                <div className="card">
                                                    <div className="card-header card-header-product">Detail Product</div>
                                                    <div className="card-body" style={{ minHeight: 250 }} id="modal-product-detail">
                                                        {!state.showProduct ?
                                                            <div>
                                                                <div className="row h-100 justify-content-center align-items-center">
                                                                    <i className="bi bi-x-circle-fill" style={{ fontSize: 50 }}></i>
                                                                </div>
                                                                <br />
                                                                <p style={{ textAlign: 'center' }}>Product not found!  <br />Please Select Product</p>
                                                            </div>
                                                            :
                                                            <div>
                                                                <div className='row h-100 justify-content-center align-items-center'>
                                                                    <p className='title-choose-produk'>{state.opsiProduct.itemname} ({state.opsiProduct.itemno})</p>
                                                                    {/*<p className='title-choose-produk'>Gudang:{state.opsiProduct.gudang_ready}</p>*/}
                                                                    <div className='col-sm-10 mb-3'>
                                                                        {/*<p className='title-choose-produk'>Choose Grade (for <b>indent</b> items only):</p>
                                                                                    <p className='title-choose-produk'>Gudang:{state.opsiProduct.gudang_indent}</p>*/}
                                                                        <label>Select Warehouse: </label>
                                                                        <select className='form-control ps-0' onChange={onChangeWarehouse} disabled={(!indent_warehouses || indent_warehouses.length == 0)}>
                                                                            {indent_warehouses.map(item => {
                                                                                return (
                                                                                    <option value={item.gudang} data-stock={item.stok}>{item.gudang}</option>
                                                                                )

                                                                            })}
                                                                            {/* <option value='C'>Grade C</option> */}
                                                                        </select>
                                                                    </div>
                                                                    <div className='col-sm-5'>
                                                                        <div className="form-check form-check-inline" style={{ textAlign: 'center', paddingLeft: 0, display: 'block' }}>
                                                                            <input className="form-check-input radio-helper" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="Ready" checked={state.opsiProduct.type == "Ready"} onChange={(e) => onRadioChange(e, state.opsiProduct.gudang_ready)} disabled={state.opsiProduct.qty_ready < 1} /><br />
                                                                            <label className="form-check-label" htmlFor="inlineRadio2">Ready</label><br />
                                                                            <span className='angka-stock'>{state.opsiProduct.qty_ready}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-sm-5' style={{ display: 'none' }}>
                                                                        <div className="form-check form-check-inline" style={{ textAlign: 'center', paddingLeft: 0, display: 'none' }}>
                                                                            <input className="form-check-input radio-helper" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="Indent" checked={state.opsiProduct.type == "Indent"} onChange={(e) => onRadioChange(e, state.opsiProduct.gudang_indent)} disabled={state.opsiProduct.qty_indent < 1} /><br />
                                                                            <label className="form-check-label" htmlFor="inlineRadio3">Indent</label><br />
                                                                            <span className='angka-stock'>{state.opsiProduct.qty_indent}</span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div className='row' style={{ marginTop: 30 }}>
                                                                    <div className="col-sm-5 col-md-8 mx-auto pl-0 pr-0">
                                                                        <div className="qty-box">
                                                                            <span className="minus-box bg-dark" onClick={() => minus(0)}>-</span>
                                                                            <input type="number" className="input-qty counter" name="qty" value={state.opsiProduct.qty} onChange={(event) => { }} />
                                                                            <span className="plus-box bg-dark" onClick={() => plus(0)}>+</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-sm-7 col-md-12 pl-0 pr-0 pt-2'>
                                                                        <p className='price pt-1'>{state.opsiProduct.mata_uang} {NumberFormat(state.opsiProduct.price)}</p>
                                                                    </div>
                                                                </div>
                                                                <div className='row h-100 justify-content-center align-items-center mt-3'>
                                                                    <button className="btn btn-dark" type="button" style={{ width: '100%' }} onClick={() => addProductDetail(state.opsiProduct)}>
                                                                        <span className='fas fa-plus'></span> Add Product
                                                                    </button>
                                                                    <button className="btn btn-dark"
                                                                        style={{ width: '100%', marginTop: 10 }}
                                                                        type="button" onClick={() => getPreorderCampaign(state.opsiProduct)}>
                                                                        Get Preorder
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="card-body" style={{ minHeight: 250, display: 'none' }} id="modal-product-preorder">
                                                        <div>
                                                            <div className='row h-100 justify-content-center align-items-center'>
                                                                <p className='title-choose-produk'>{state.opsiProduct.itemname}<br />({state.opsiProduct.itemno})</p>
                                                            </div>
                                                            Preorder Campaign Available
                                                            <div style={{ paddingTop: '17px', paddingBottom: '17px' }}>
                                                                {
                                                                    statePreorder.length > 0 && statePreorder.map((item, index) => {
                                                                        let dealer_id = userInfo.MI_cardcode.filter((order_type) => order_type.U_M_TP_TRSKS === 'FGS')[0].U_M_BP_CODE_MI;
                                                                        return (
                                                                            <div style={{ textAlign: 'left', paddingBottom: '17px' }}>
                                                                                <span><span style={{ fontWeight: 'bold' }}>#{index + 1} <a href='javascript:void(0)' onClick={() => detailPreorderCampaign(item.paketid, state.opsiProduct.itemno, dealer_id)}>{item.paketid}</a></span><br />{item.keterangan_paket}</span>
                                                                                {
                                                                                    statePreorderDetail.paketid === item.paketid &&
                                                                                    <div>
                                                                                        <span style={{ fontWeight: 'bold' }}>Kuota: {statePreorderDetail.kuota}</span><br />
                                                                                        <div style={{ display: 'flex' }}>
                                                                                            <input type="number" className="form-control" disabled={statePreorderDetail.kuota <= 0 ? true : false} placeholder="Qty" style={{ width: "50%", borderTopRightRadius: '0', borderBottomRightRadius: '0' }} value={statePreorderDetail.kuota <= 0 ? 0 : statePreorderQty} onChange={(e) => onChangeQtyPreorder(e, statePreorderDetail.kuota)} />
                                                                                            <button className="btn btn-dark" disabled={statePreorderDetail.kuota <= 0 ? true : false} style={{ width: '50%', borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }} type="button" onClick={() => addProductDetailPreorder(state.opsiProduct, statePreorderDetail)}>Add Product</button>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                            <button className="btn btn-dark"
                                                                // disabled={!state.enable_add_product_detail}
                                                                style={{ width: '100%', marginTop: 10 }}
                                                                type="button" onClick={() => backFromPreorderCampaign()}>
                                                                Back
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                    <div id="modal-product-diskon-free" className='modal'>
                        <form name="form-product-free">
                            <div className='modal-dialog modal-dialog-centered modal-xl'>
                                <div className='modal-content'>
                                    <div className='modal-header'>
                                        <h5 className="modal-title"> Product List</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className='modal-body'>
                                        <div className="row">
                                            <div className='col-sm-8'>
                                                <MTable ref={mTableF} {...propsTableProductFree} />
                                            </div>
                                            <div className='col-sm-4'>
                                                <Overlay display={state.processing} />
                                                <div className="card">
                                                    <div className="card-header card-header-product">Detail Product</div>
                                                    <div className="card-body" style={{ minHeight: 250 }}>
                                                        {!state.showProduct ?
                                                            <div>
                                                                <div className="row h-100 justify-content-center align-items-center">
                                                                    <i className="bi bi-x-circle-fill" style={{ fontSize: 50 }}></i>
                                                                </div>
                                                                <br />
                                                                <p style={{ textAlign: 'center' }}>Product not found!  <br />Please Select Product</p>
                                                            </div>
                                                            :
                                                            <div>
                                                                <div className='row h-100 justify-content-center align-items-center' style={{ marginBottom: "20px" }}>
                                                                    {/*<p className='title-choose-produk'>Choose Grade (for <b>indent</b> items only):</p>
                                                                                <p className='title-choose-produk'>Gudang:{state.opsiProduct.gudang_indent}</p>*/}
                                                                    <label>Select Warehouse: </label>
                                                                    <select className='form-control ps-0' onChange={onChangeWarehouseFree} style={{ width: "70%" }} disabled={(!indent_warehouses || indent_warehouses.length == 0)}>
                                                                        {indent_warehouses.map(item => {
                                                                            return (
                                                                                <option value={item.gudang} data-stock={item.stok}>{item.gudang}</option>
                                                                            )

                                                                        })}
                                                                        {/* <option value='C'>Grade C</option> */}
                                                                    </select>
                                                                </div>
                                                                <div className='row h-100 justify-content-center align-items-center'>

                                                                    <p className='title-choose-produk'>{state.opsiProductFree.itemname} ({state.opsiProductFree.itemno})</p>
                                                                    <p className='price pt-1' style={{ fontWeight: 700, fontSize: 18 }}>{state.opsiProductFree.mata_uang} {NumberFormat(state.opsiProductFree.price)}</p>

                                                                </div>
                                                                <div className='row' style={{ marginTop: 30 }}>
                                                                    <div className="col-sm-5 pl-0 pr-0">
                                                                        <div className="qty-box d-flex">
                                                                            <span className="minus-box bg-dark" onClick={() => {
                                                                                if (state.opsiProductFree.qty_ready > 0 && state.opsiProductFree.qty > 0)
                                                                                    minus(1)
                                                                            }}>-</span>
                                                                            <input type="number" className="input-qty counter" name="qty" value={state.opsiProductFree.qty} onChange={(event) => { }} />
                                                                            <span className="plus-box bg-dark" onClick={() => plus(1)}>+</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-sm-7 pl-0 pr-0'>
                                                                        <p className='price pt-1'>Stok : <span className='angka-stock'>{state.opsiProductFree.qty_ready}</span></p>
                                                                    </div>
                                                                </div>
                                                                <div className='row h-100 justify-content-center align-items-center mt-4'>
                                                                    <button className="btn btn-dark" type="button"
                                                                        disabled={state.opsiProductFree.qty_ready <= 0 || state.opsiProductFree.qty <= 0} onClick={() => addProductDetailFree(state.opsiProductFree)}>
                                                                        <span className='fas fa-plus'></span> Add Free Item
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default PurchaseForm;